import config from "./config";
import axios from "axios";
import $, { each } from "jquery";
import {
  filter,
  find,
  isEmpty,
  size,
  findIndex,
  some,
  every,
  forEach,
  findLast,
  orderBy,
  shuffle,
  merge,
  forIn,
} from "lodash";
import moment from "moment";
import { WebConfigDataContext } from "../Context";

String.prototype.si_hexEncode = function () {
  var hex, i;

  var result = "";
  for (i = 0; i < this.length; i++) {
    hex = this.charCodeAt(i).toString(16);
    result += ("000" + hex).slice(-4);
  }

  return result;
};

String.prototype.si_hexDecode = function () {
  var j;
  var hexes = this.match(/.{1,4}/g) || [];
  var back = "";
  for (j = 0; j < hexes.length; j++) {
    back += String.fromCharCode(parseInt(hexes[j], 16));
  }

  return back;
};

export const headers = {
  entity: "ed0t4n$3!",
  "Content-Type": "application/json",
  Accept: "application/json",
};

const orderToScan = ["4", "3", "2", "1", "0"];
const clone = require("fast-clone");

export const getData = (apiParams, cb, errCb) => {
  //make api cached
  makeAPICallAxios(apiParams, cb, errCb);
};

const getBusterStr = () => {
  return Math.random().toString(36).substr(2, 9) + Date.now();
};
export const updateBusters = (postAPI) => {
  for (let j = 0; j < config.bustersConfig[postAPI].length; j++) {
    const getAPI = config.bustersConfig[postAPI][j];
    localStorage.setItem(`_buster_${getAPI}`, getBusterStr());
  }
};
export const getParams = () => {
  return window.location.search;
};
export const getQueryParamsObject = () => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  return params;
};
((busters) => {
  Object.keys(busters).forEach((postAPI) => {
    busters[postAPI].forEach((getAPI) => {
      const valueSetInLocalStorage = localStorage.getItem(`_buster_${getAPI}`);
      if (!valueSetInLocalStorage) {
        localStorage.setItem(`_buster_${getAPI}`, getBusterStr());
      }
    });
  });
})(config.bustersConfig);

const isWordLastInString = (str, word) => {
  const index = str.lastIndexOf(word);
  return index > -1 && index === str.length - word.length;
  // return true;
};

const makeQueryString = (data, url, isJson) => {
  if (isJson) {
    var queryNew = "";
    if (Object.keys(data).length !== 0 && data.constructor === Object) {
      Object.keys(data).forEach(function (item) {
        queryNew = url.replace("{{" + item + "}}", data[item]);
        url = queryNew;
      });
    } else {
      queryNew = url;
    }

    if (data.buster) {
      queryNew = queryNew + "?buster=" + data.buster;
    }
    return queryNew;
  } else {
    var query = "";
    query = Object.keys(data)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(data[k]))
      .join("&");
    return query ? "?" + query : "";
  }
};

export const makeAPICallAxios = (apiParams, successCB, failedCB) => {
  let buster = "";
  if (apiParams.type === "GET") {
    const keys = Object.keys(config.bustersConfig);
    parent: for (let i = 0; i < keys.length; i++) {
      const postAPI = keys[i];
      for (let j = 0; j < config.bustersConfig[postAPI].length; j++) {
        const getAPI = config.bustersConfig[postAPI][j];
        if (
          isWordLastInString(apiParams.endPoint, getAPI) ||
          apiParams.endPoint.includes(getAPI)
        ) {
          buster = localStorage.getItem(`_buster_${getAPI}`);
          apiParams.params.buster = buster;
          break parent;
        }
      }
    }
  }
  const isJSON = apiParams.endPoint.indexOf(".json") > -1;
  const apiObj = {
    method: apiParams.type,
    name: apiParams.name,
  };
  if (!isJSON) {
    apiObj.headers = config.headers;
    apiObj.credentials = "include";
  }
  if (apiObj.method === "GET") {
    buster && (apiParams.buster = buster);
    if (isJSON) {
      apiParams.endPoint = makeQueryString(
        apiParams.params,
        apiParams.endPoint,
        isJSON
      );
    } else {
      apiParams.endPoint =
        apiParams.endPoint + makeQueryString(apiParams.params);
    }
  } else {
    apiObj.data = JSON.stringify(apiParams.params);
    apiObj.method = "POST";
  }
  apiObj.url = apiParams.endPoint;

  return axios(apiObj)
    .then((response) => {
      window.serverDate = response.headers.date;
      if (response.status != 200) {
        throw Error(response.statusText);
      } else {
        const responseData = response.data;

        const data =
          typeof responseData == "string"
            ? JSON.parse(responseData.trim())
            : responseData;
        if (data.Meta["Success"]) {
          if (apiParams.type === "POST") {
            const keys = Object.keys(config.bustersConfig);
            for (let i = 0; i < keys.length; i++) {
              const postAPI = keys[i];
              if (apiParams.endPoint.indexOf(postAPI) > -1) {
                updateBusters(postAPI);
                break;
              }
            }
          }
        }

        if (data.Meta["Success"] && data.Meta["RetVal"] === 1) {
          if (successCB) {
            successCB(data);
          }
        } else {
          hideLoader();
          if (failedCB) {
            data.Meta.ErrVal = data;
            failedCB(data.Meta);
          }
        }
      }
    })
    .catch((e) => {
      hideLoader();
      if (failedCB) {
        failedCB();
      }
    });
};

//create team data functions

export function getInTeamArray(teamData, oldTeamData) {
  let diff = [];
  const areBothDataSameInSkeleton = every(orderToScan, (i) => {
    return (
      oldTeamData[i] &&
      teamData[i] &&
      oldTeamData[i].length === teamData[i].length
    );
  });
  if (areBothDataSameInSkeleton) {
    forEach(orderToScan, (skillIndex) => {
      const difference = filter(teamData[skillIndex], (player, index) => {
        let playerNotfound = oldTeamData[skillIndex].every(function (
          oldPly,
          index
        ) {
          if (oldPly.id == player.id) {
            return false;
          } else {
            return true;
          }
        });
        if (playerNotfound) {
          return playerNotfound;
        } else {
          return player.id !== oldTeamData[skillIndex][index].id;
        }
      });

      let currDiff = filter(difference, (player) => player.Id !== null);
      if (currDiff.length) diff = diff.concat(currDiff);
    });
  }
  return diff;
}

export function getSubstitutionsApiData(teamData) {
  let data = {
    SubPlayerId: [],
    SubPlayerBenchPosition: [],
  };
  orderToScan.forEach((skillIndex) => {
    teamData[skillIndex].forEach((player, index) => {
      if (player.substituted === true) {
        data.SubPlayerId.push(player.id);
        data.SubPlayerBenchPosition.push(player.isBench ? index + 1 : 0);
      }
    });
  });
  return data;
}

export function getPlayerByKeyFromTeamData(teamData, key, value) {
  let playerData = {};
  find(orderToScan, (position) => {
    return find(teamData[position], (player, index) => {
      if (player[key] === value) {
        playerData = {
          skill: player.skill,
          rowIndex: position,
          playerIndex: index,
          data: player,
        };
        return true;
      }
      return false;
    });
  });
  return playerData;
}

export function canPlayerSubstitute(player) {
  const { DBDetails } = player;
  if (DBDetails) {
    const IsPlayed = +DBDetails.IsPlayed === 1;
    const isBench = DBDetails["BenchPosition"] > 0;
    const RC = DBDetails["IsRedcard"] === 1;
    if (isBench && IsPlayed) {
      return false;
    }
    return !RC;
  }
}

export function canPlayerSubstituteNew(player) {
  const { DBDetails } = player;
  if (DBDetails) {
    const IsPlayed = +DBDetails["Isplayed"] === 1;
    const isBench = DBDetails["BenchPosition"] > 0;
    const RC = DBDetails["IsRedCard"] === 1;
    if (isBench && IsPlayed) {
      return false;
    }
    return !RC;
  }
}

export function validateEmail(sEmail) {
  let re =
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(sEmail);
}

export function validateUsername(name) {
  return name.length > 2 && name.length < 26;
}

export function isNumberKey(evt) {
  var charCode = evt.which ? evt.which : evt.keyCode;
  if (charCode > 31 && (charCode < 48 || charCode > 57)) return false;
  return true;
}

function getFirstPositionToHighlight(teamData) {
  updatePropInTeam(teamData, "isHighlighted", false);
  let highlightPosition = {};
  orderToScan.some((key) => {
    return teamData[key].some((player, index) => {
      if (player.id === null) {
        player.isHighlighted = true;
        highlightPosition = {
          skill: player.skill,
          rowIndex: key,
          playerIndex: index,
        };
        return true;
      }
      return false;
    });
  });
  return highlightPosition;
}

function updatePropInTeam(teamData, key, value) {
  orderToScan.forEach((position) => {
    teamData[position].forEach((player) => {
      player[key] = value;
    });
  });
}

//This function checks which is new player and which is old player
function differentiateNewPlayers(teamData, oldTeamData) {
  const diffArray = getInTeamArray(teamData, oldTeamData);
  updatePropInTeam(teamData, "isNew", false);
  diffArray.forEach((player) => {
    player.isNew = true;
  });
}
export function createTeamData(state) {
  const { constraints, formations, newFormationId, playerPos, teamData } =
    state;
  const { MaxTeamValue, MaxTeamPlayers } = constraints || {};
  const comp =
    find(formations, { CompId: newFormationId }) || formations[newFormationId];
  console.log(comp);
  const selForm = comp; // formations[newFormationId]; //find(formations, { CompId: newFormationId });
  console.log(config.WebConfig.MAX_FORMATION_COMP_ID);
  let maxFormation = formations[config.WebConfig.MAX_FORMATION_COMP_ID]; //find(formations, { CompId: config.MAX_FORMATION_COMP_ID }) || {};
  let rawTeamData = JSON.parse(JSON.stringify(teamData || {}));
  const playerObj = {
    id: null,
    details: {},
    isBench: false,
    isHighlighted: false,
    isCaptain: false,
    skill: null,
  };
  const getInitialSkeleton = (rawTeamData, selForm, maxFormation = {}) => {
    rawTeamData[0] = [];
    playerPos.forEach((skill, i) => {
      const key = i + 1;
      rawTeamData[key] = [];
      for (let j = 1; j <= +maxFormation[skill]; j++) {
        if (selForm[skill] >= j) {
          rawTeamData[key].push({ ...playerObj, skill: key });
        } else {
          rawTeamData[0].push({ ...playerObj, isBench: true, skill: key });
        }
      }
    });
    rawTeamData[0] = rawTeamData[0].sort((a, b) => {
      return a.skill - b.skill;
    });
    return rawTeamData;
  };
  if (isEmpty(rawTeamData)) {
    rawTeamData.budget = MaxTeamValue;
    rawTeamData.playerCount = 0;
    rawTeamData.captainID = null;
    rawTeamData.badgeID = null;
    rawTeamData.teamName = null;
    rawTeamData.clubID = null;
    rawTeamData.playersInTeam = [];
    rawTeamData.maxPos = [
      maxFormation.GK,
      maxFormation.DEF,
      maxFormation.MID,
      maxFormation.FWD,
    ];
    rawTeamData.max_playerPerTeam = MaxTeamPlayers; // Maximum number of players allowed from a team
    rawTeamData = getInitialSkeleton(rawTeamData, selForm, maxFormation);
    const highlightedSkill = getFirstPositionToHighlight(rawTeamData);
    setLocalStorage("teamData", { ...rawTeamData, highlightedSkill });
    return { ...rawTeamData, highlightedSkill };
  } else {
    let oldDataForDiff = JSON.parse(JSON.stringify(rawTeamData));
    let tempOldData = JSON.parse(JSON.stringify(rawTeamData));
    let newRawData = getInitialSkeleton(rawTeamData, selForm, maxFormation);
    const findPositionFilledJerseyAndReturn = (skill) => {
      for (let j = 0; j < tempOldData[skill].length; j++) {
        if (
          tempOldData[skill][j].skill === skill &&
          tempOldData[skill][j].id !== null
        ) {
          const dataToReturn = JSON.parse(
            JSON.stringify(tempOldData[skill][j])
          );
          tempOldData[skill][j] = { ...playerObj };
          return dataToReturn;
        }
      }
      for (let j = 0; j < tempOldData["0"].length; j++) {
        if (
          tempOldData["0"][j].skill === skill &&
          tempOldData["0"][j].id !== null
        ) {
          const dataToReturn = JSON.parse(JSON.stringify(tempOldData["0"][j]));
          tempOldData["0"][j] = { ...playerObj };
          return dataToReturn;
        }
      }
      return {};
    };
    const getLastEmptyPosition = (newRawData, skillIndex) => {
      for (let i = newRawData[skillIndex].length; i--; ) {
        if (newRawData[skillIndex][i].id === null) {
          return i;
        }
      }
    };
    for (let i = 0, iLen = orderToScan.length; i < iLen; i++) {
      let skillIndex = orderToScan[i];
      for (let j = 0, jLen = tempOldData[skillIndex].length; j < jLen; j++) {
        const foundJersey = tempOldData[skillIndex][j];
        if (foundJersey.DBDetails && !canPlayerSubstitute(foundJersey)) {
          let newIndexForCaptain = 0;
          if (j < newRawData[skillIndex].length) {
            newIndexForCaptain = j;
          } else {
            newIndexForCaptain = getLastEmptyPosition(newRawData, skillIndex);
          }
          const isBench = skillIndex === "0";
          const isCaptain = foundJersey.isCaptain;
          if (skillIndex === "0") {
            newIndexForCaptain = findIndex(newRawData[skillIndex], (jersey) => {
              return jersey.skill === foundJersey.skill && jersey.id === null;
            });
            newRawData[skillIndex][newIndexForCaptain] = {
              ...foundJersey,
              isCaptain,
              isBench,
            };
            tempOldData[skillIndex][j] = { ...playerObj };
          } else {
            newRawData[skillIndex][newIndexForCaptain] = {
              ...foundJersey,
              isCaptain,
              isBench,
            };
            tempOldData[skillIndex][j] = { ...playerObj };
          }
        }
      }
    }
    orderToScan.forEach((positionKey) => {
      newRawData[positionKey].forEach((newJersey, jIndex) => {
        if (newJersey.id === null) {
          let foundJersey = findPositionFilledJerseyAndReturn(newJersey.skill);
          if (!isEmpty(foundJersey)) {
            const isBench = positionKey === "0";
            const isCaptain = foundJersey.isCaptain;
            newRawData[positionKey][jIndex] = {
              ...foundJersey,
              isCaptain,
              isBench,
            };
          }
        }
      });
    });
    rawTeamData[0] = rawTeamData[0].sort((a, b) => {
      return a.skill - b.skill;
    });
    rawTeamData[0].forEach((player, index) => {
      const getPlayerIndexInBench = (playerID) => {
        return findIndex(oldDataForDiff[0], { id: playerID });
      };
      const playerOldIndexInBench = getPlayerIndexInBench(player.Id);
      if (
        player.Id &&
        playerOldIndexInBench > -1 &&
        playerOldIndexInBench !== index
      ) {
        const A = JSON.parse(JSON.stringify(rawTeamData[0][index]));
        const B = JSON.parse(
          JSON.stringify(rawTeamData[0][playerOldIndexInBench])
        );
        rawTeamData[0][playerOldIndexInBench] = A;
        rawTeamData[0][index] = B;
      }
    });
    const isCaptainInBench = (teamData) => {
      return teamData[0].some((el) => el.isCaptain === true);
    };
    if (isCaptainInBench(rawTeamData)) {
      const updatedTeamData = getAutoSubstitutionsApiData(
        rawTeamData,
        oldDataForDiff
      );
      const getSubsData = getSubstitutionsApiData(updatedTeamData);
      const newCaptainIndex = findIndex(
        getSubsData.SubPlayerBenchPosition,
        (benchPosition) => {
          return benchPosition === 0;
        }
      );
      if (newCaptainIndex > -1) {
        const newCaptainID = getSubsData.SubPlayerId[newCaptainIndex];
        rawTeamData.captainID = newCaptainID;
        updatePropInTeam(rawTeamData, "isCaptain", false);
        const newCaptainObj = getPlayerByKeyFromTeamData(
          rawTeamData,
          "id",
          newCaptainID
        );
        if (!isEmpty(newCaptainObj)) {
          newCaptainObj.data.isCaptain = true;
        }
      }
    }
    const highlightedSkill = getFirstPositionToHighlight(newRawData);
    setLocalStorage("teamData", { ...newRawData, highlightedSkill });
    return { ...newRawData, highlightedSkill };
  }
}
export const getCaptain = (teamData) => {
  let player = {};
  forEach(orderToScan, (skillIndex) => {
    const playerT = find(teamData[skillIndex], (player, index) => {
      return player.isCaptain;
    });
    if (playerT) {
      player = playerT;
    }
  });
  return player;
};

export const getBoosterCaptain = (teamData, id) => {
  let player = {};
  forEach(orderToScan, (skillIndex) => {
    const playerT = find(teamData[skillIndex], (player, index) => {
      return (
        player.details.IsCaptain === config.boosterCaptain ||
        player.details.Id === id
      );
    });
    if (playerT) {
      player = playerT;
    }
  });
  return player;
};

export const getAppliedBooster = (boosters, gamedayId) => {
  let boosterApplied = boosters?.find((obj) => {
    return obj.GdId === gamedayId && obj.IsTaken;
  });
  return boosterApplied;
};

export const getPlayerBoosterCoefficient = (player, booster) => {
  // console.log(player, "player");
  let playerXCoef = 1;
  switch (booster.BoosterId) {
    case 1:
      playerXCoef = player.details?.IsCaptain === 1 ? 3 : 1;
      break;
    case 2:
      playerXCoef = player.details?.IsBench === 1 && 1;
      break;
    case 3:
      playerXCoef = player.details?.IsCaptain === 1 ? 2 : 1;
      break;
    case 4:
      playerXCoef = player.details?.IsCaptain === 1 ? 2 : 1;
      break;
    case 5:
      playerXCoef =
        player.details.Skill == config.EnumPosition.Defenders
          ? player.isCaptain
            ? 4
            : 2
          : null;
      if (
        player.details.Skill === config.EnumPosition.Defenders &&
        player.isBench
      ) {
        playerXCoef = 1;
      }
      break;
    case 6:
      playerXCoef =
        player.details.Skill == config.EnumPosition.Forwards
          ? player.isCaptain
            ? 4
            : 2
          : null;
      if (
        player.details.Skill === config.EnumPosition.Forwards &&
        player.isBench
      ) {
        playerXCoef = 1;
      }
      break;
    case 7:
      playerXCoef =
        player.details.IsCaptain === 1 || player.details.IsCaptain === 7
          ? 2
          : 1;
      break;
    case 8:
      playerXCoef =
        player.details.Skill == config.EnumPosition.Goalkeepers
          ? player.isCaptain
            ? 4
            : 2
          : null;
      if (
        player.details.Skill === config.EnumPosition.Goalkeepers &&
        player.isBench
      ) {
        playerXCoef = 1;
      }
      break;
  }
  return playerXCoef;
};

export const getBoosterClass = (booster) => {
  switch (booster.BoosterId) {
    case 1:
      return "si-trCa";
      break;
    case 2:
      return "si-beBo";
      break;
    case 3:
      return "si-riUn";
      break;
    case 4:
      return "si-frHi";
      break;
    case 5:
      return "si-paBu";
      break;
    case 6:
      return "si-alAt";
      break;
    case 7:
      return "si-twCa";
      break;
    case 8:
      return "si-suGo";
      break;
  }
};

export const getTransferArray = (teamdata, isBenchPos) => {
  let transferArray = [];
  forEach(orderToScan, (skillIndex) => {
    teamdata[skillIndex].forEach((player, index) => {
      let objTransfer = {};
      objTransfer.playerId = player.id;
      isBenchPos &&
        (objTransfer.benchPosition = skillIndex === "0" ? index + 1 : 0);
      transferArray.push(objTransfer);
    });
  });
  return transferArray;
};
export const numToWord = (num) => {
  const a = [
    "",
    "one ",
    "two ",
    "three ",
    "four ",
    "five ",
    "six ",
    "seven ",
    "eight ",
    "nine ",
    "ten ",
    "eleven ",
    "twelve ",
    "thirteen ",
    "fourteen ",
    "fifteen ",
    "sixteen ",
    "seventeen ",
    "eighteen ",
    "nineteen ",
  ];
  return a[num];
};

export const makeClasses = (obj = {}) => {
  return Object.keys(obj)
    .filter((key) => obj[key])
    .join(" ");
};

export function getTrans(data, key, fallback) {
  if (config.printExcel) {
    //check if key is already pushed
    let addKey = true;
    for (var i = 0; i < window[config.namespaceKey].trans.length; i++) {
      var inArrayKey = window[config.namespaceKey].trans[i];
      if (inArrayKey[0] == key) {
        addKey = false;
      }
    }
    if (addKey) {
      window[config.namespaceKey].trans.push([key, fallback]);
    }
  }

  if (data) {
    return data[key] ? data[key] : fallback ? fallback : key;
  } else {
    return fallback ? fallback : "";
  }
}

export function addPlayer(
  data,
  playerObj = {},
  skillId,
  rowIndex,
  playerIndex,
  manageTeamRawData,
  skillFilters,
  isRecover = false
) {
  const isManageTeam = !isEmpty(manageTeamRawData); //false; //common.isManageTeam();

  if (isManageTeam) {
    let configObj = { EnumMaxPositionNos: {} };
    configObj.EnumMaxPositionNos[1] = data.maxPos[0];
    configObj.EnumMaxPositionNos[2] = data.maxPos[1];
    configObj.EnumMaxPositionNos[3] = data.maxPos[2];
    configObj.EnumMaxPositionNos[4] = data.maxPos[3];
    let teamData = JSON.parse(JSON.stringify(data)); //clone(data);
    let playerID = playerObj.Id;
    let playerIDInSkills = findIndex(
      teamData[skillId],
      (player) => player.id === playerID
    );
    let playerIDInBench = findIndex(
      teamData[0],
      (player) => player.id === playerID
    );
    // /**/
    let emptyIndexOfPosition = findIndex(teamData[skillId], {
      id: null,
      DBDetails: { id: playerObj.idI },
    });
    if (emptyIndexOfPosition < 0) {
      emptyIndexOfPosition = findIndex(teamData[skillId], { id: null });
    }
    // let emptyIndexOfPosition = findIndex(teamData[skillId], { id: null });
    let emptyIndexOfBench = findIndex(teamData[0], {
      id: null,
      skill: skillId,
    });
    let errorObj = {};
    if ((playerIndex > -1 && playerIndex != undefined) || playerIndex != null) {
    } else {
      if (emptyIndexOfBench > -1) {
        playerIndex = emptyIndexOfBench;
      }
      if (emptyIndexOfPosition > -1) {
        playerIndex = emptyIndexOfPosition;
      }
    }
    /**/
    if (playerIDInSkills > -1) {
      let returnedRemovePlayer = manageTeamRemovePlayer(
        teamData,
        rowIndex,
        playerIDInSkills,
        playerID,
        +playerObj.Value,
        playerObj.Skill
      );
      // makeJerseyAnimate(rowIndex);
      teamData = returnedRemovePlayer.teamDATA;
    } else if (playerIDInBench > -1) {
      let returnedRemovePlayer = manageTeamRemovePlayer(
        teamData,
        0,
        playerIDInBench,
        playerID,
        +playerObj.Value,
        playerObj.Skill
      );
      // makeJerseyAnimate(0);
      teamData = returnedRemovePlayer.teamDATA;
    } else if (emptyIndexOfPosition > -1) {
      let returnedAddPlayer = manageTeamAddPlayer(
        teamData,
        rowIndex,
        playerIndex,
        playerObj,
        manageTeamRawData,
        skillId,
        configObj
      );
      // makeJerseyAnimate(rowIndex);
      teamData = returnedAddPlayer.teamDATA;
      errorObj = returnedAddPlayer.errorOBJ;
    } else if (emptyIndexOfBench > -1) {
      let returnedAddPlayer = manageTeamAddPlayer(
        teamData,
        0,
        playerIndex,
        playerObj,
        manageTeamRawData,
        skillId,
        configObj
      );
      // makeJerseyAnimate(0);
      teamData = returnedAddPlayer.teamDATA;
      errorObj = returnedAddPlayer.errorOBJ;
    } else {
      errorObj.maxSkill = configObj.EnumMaxPositionNos[skillId];
      errorObj.playersPerSkillCountExceeded = true;
      errorObj.skill = skillId;
    }
    teamData.budget = (+teamData.budget).toFixed(1);
    differentiateNewPlayers(teamData, manageTeamRawData);
    return { teamData, errorObj };
  } else {
    let configObjT = { EnumMaxPositionNos: {} };
    configObjT.EnumMaxPositionNos[1] = data.maxPos[0];
    configObjT.EnumMaxPositionNos[2] = data.maxPos[1];
    configObjT.EnumMaxPositionNos[3] = data.maxPos[2];
    configObjT.EnumMaxPositionNos[4] = data.maxPos[3];
    let errorObj = {
      playersPerSkillCountExceeded: false,
      playersPerTeamCountExceeded: false,
      skill: null,
      team: null,
    };
    let teamDataT = JSON.parse(JSON.stringify(data)); //clone(data);
    let playerIDT = playerObj.Id;
    let playerIDInSkillsT = findIndex(
      teamDataT[skillId],
      (player) => player.id === playerIDT
    );
    let playerIDInBenchT = findIndex(
      teamDataT[0],
      (player) => player.id === playerIDT
    );
    /**/
    let emptyIndexOfPositionT = findIndex(teamDataT[skillId], { id: null });
    let emptyIndexOfBenchT = findIndex(teamDataT[0], {
      id: null,
      skill: skillId,
    });
    /**/
    if (playerIDInSkillsT > -1) {
      let returnedRemovePlayer = createTeamRemovePlayer(
        teamDataT,
        skillId,
        playerIDInSkillsT,
        playerObj,
        skillId
      );
      // makeJerseyAnimate(skillId);
      teamDataT = returnedRemovePlayer.teamDATA;
    } else if (playerIDInBenchT > -1) {
      // createTeamRemovePlayer(teamDataT, 0, playerIDInBench);
      let returnedRemovePlayer = createTeamRemovePlayer(
        teamDataT,
        0,
        playerIDInBenchT,
        playerObj,
        skillId
      );
      // makeJerseyAnimate(0);
      teamDataT = returnedRemovePlayer.teamDATA;
    } else if (emptyIndexOfPositionT > -1) {
      if (skillFilters.length != 1) {
        // do nothing add player according to new logic of skill
        let returnedAddPlayer = createTeamAddPlayer(
          teamDataT,
          skillId,
          playerIndex,
          playerObj,
          skillId,
          configObjT.EnumMaxPositionNos[skillId],
          skillFilters,
          errorObj
        );

        teamDataT = returnedAddPlayer.teamDATA;
        errorObj = returnedAddPlayer.errorOBJ;
      } else {
        let returnedAddPlayer = createTeamAddPlayer(
          teamDataT,
          rowIndex,
          playerIndex,
          playerObj,
          skillId,
          configObjT.EnumMaxPositionNos[skillId],
          skillFilters,
          errorObj
        );

        teamDataT = returnedAddPlayer.teamDATA;
        errorObj = returnedAddPlayer.errorOBJ;
      }
    } else if (emptyIndexOfBenchT > -1) {
      if (skillFilters.length != 1) {
        // do nothing add player according to new logic
        let returnedAddPlayer = createTeamAddPlayer(
          teamDataT,
          skillId,
          playerIndex,
          playerObj,
          skillId,
          configObjT.EnumMaxPositionNos[skillId],
          skillFilters,
          errorObj
        );

        teamDataT = returnedAddPlayer.teamDATA;
        errorObj = returnedAddPlayer.errorOBJ;
      } else {
        let returnedAddPlayer = createTeamAddPlayer(
          teamDataT,
          rowIndex,
          playerIndex,
          playerObj,
          skillId,
          configObjT.EnumMaxPositionNos[skillId],
          skillFilters,
          errorObj
        );

        teamDataT = returnedAddPlayer.teamDATA;
        errorObj = returnedAddPlayer.errorOBJ;
      }
    } else {
      errorObj.maxSkill = configObjT.EnumMaxPositionNos[skillId];
      errorObj.playersPerSkillCountExceeded = true;
      errorObj.skill = skillId;
    }
    teamDataT.budget = (+teamDataT.budget).toFixed(1);
    setLocalStorage("teamData", teamDataT);
    return { teamDataT, errorObj };
  }
}
function getValidPlayersCountPerSkill(teamData, skill) {
  let count = 0;
  for (let i = 0, iLen = orderToScan.length; i < iLen; i++) {
    let skillIndex = orderToScan[i];
    for (let j = 0, jLen = teamData[skillIndex].length; j < jLen; j++) {
      const foundJersey = teamData[skillIndex][j];
      if (+foundJersey.skill === +skill && canPlayerSubstitute(foundJersey)) {
        ++count;
      }
    }
  }
  return count;
}

export function getPlayersCountSkill(teamData, skill) {
  let count = 0;
  forEach(orderToScan, (skillIndex) => {
    teamData[skillIndex].forEach((obj) => {
      obj?.skill === skill && obj?.id && ++count;
    });
  });
  return count;
}

export function makeManageTeamSkeleton(rawTeamFromDB, players, formations) {
  const rawPlayers = rawTeamFromDB.Players;
  let manageTeamData = {},
    playerCount = 0,
    playersInTeam = [];
  let captainID = null;
  let boosterCaptainId = null;
  const mapDBPlayer = (player, skill) => {
    const playerID = player.Id.toString();
    ++playerCount;
    playersInTeam.push(playerID);

    let foundPlayer = find(
      players,
      (playerFromListing) => playerFromListing.Id == playerID
    );
    let details = JSON.parse(JSON.stringify(foundPlayer));
    // const DBDetails = merge(details, JSON.parse(JSON.stringify(player)));
    player.Id = playerID;
    // try{
    //   Object.assign(details, JSON.parse(JSON.stringify(player)));
    // }catch(err){
    //   alert(err)
    // }
    if (
      player &&
      player.lineupStatus &&
      (player.lineupStatus == "B" || player.lineupStatus == "P")
    ) {
      details.pStatus = player.lineupStatus;
    }
    const DBDetails = Object.assign(
      details,
      JSON.parse(JSON.stringify(player))
    );
    // let details = player;
    // const DBDetails = details;
    DBDetails.Id = playerID;
    DBDetails.IsBench = player.BenchPosition ? true : false;
    const isCaptain = +player["IsCaptain"] === 1;
    const isBoosterCaptain = +player["IsCaptain"] === 7;
    if (isCaptain) {
      captainID = playerID;
    }
    if (isBoosterCaptain) {
      boosterCaptainId = playerID;
    }
    return {
      id: playerID,
      DBDetails,
      details,
      isCaptain: isCaptain,
      isBoosterCaptain: isBoosterCaptain,
      isHighlighted: false,
      skill: player["Skill"],
      isBench: +skill === 0,
      value: player.Value,
    };
  };
  orderToScan.forEach((skill) => {
    let filterHandler = (player) => {
      return player["BenchPosition"] === 0 && player["Skill"] === +skill;
    };
    if (skill === "0") {
      filterHandler = (player) => {
        return player["BenchPosition"] > 0;
      };
    }
    let playersOfThatSkill = filter(rawPlayers, filterHandler);
    if (skill === "0") {
      playersOfThatSkill = sortBy(playersOfThatSkill, "BenchPosition", "ASC");
    }
    manageTeamData[skill] = playersOfThatSkill.map((player) => {
      return mapDBPlayer(player, skill);
    });
  });
  let maxFormation = formations[config.WebConfig.MAX_FORMATION_COMP_ID]; //find(formations, formation => +formation.CompId === +config.MAX_FORMATION_COMP_ID);
  manageTeamData.maxPos = [
    maxFormation.GK,
    maxFormation.DEF,
    maxFormation.MID,
    maxFormation.FWD,
  ];
  let clonedRawTeamFromDB = JSON.parse(JSON.stringify(rawTeamFromDB));
  delete clonedRawTeamFromDB.Players;
  const { MaxTeamPlayers } = clonedRawTeamFromDB;
  manageTeamData.max_playerPerTeam = MaxTeamPlayers;
  manageTeamData.budget = rawTeamFromDB["TeamBalance"];
  manageTeamData.playerCount = playerCount;
  manageTeamData.playersInTeam = playersInTeam;
  manageTeamData.captainID = captainID;
  manageTeamData.boosterCaptainId = boosterCaptainId;
  manageTeamData.CompId = rawTeamFromDB.GDCompId;
  manageTeamData = merge(manageTeamData, clonedRawTeamFromDB);
  const fwd = getValidPlayersCountPerSkill(
    manageTeamData,
    config.EnumPosition.Forwards
  );
  const mid = getValidPlayersCountPerSkill(
    manageTeamData,
    config.EnumPosition.Midfielders
  );
  const def = getValidPlayersCountPerSkill(
    manageTeamData,
    config.EnumPosition.Defenders
  );
  let fwdL = manageTeamData[4].length;
  let midL = manageTeamData[3].length;
  let defL = manageTeamData[2].length;
  for (let f in formations) {
    if (f !== "defaultCompId") {
      let formation = formations[f];
      formation.IsActive =
        formation.FWD <= fwd && formation.MID <= mid && formation.DEF <= def;
      if (
        formation.FWD == fwdL &&
        formation.MID == midL &&
        formation.DEF == defL
      ) {
        manageTeamData.CompId = formations[f].CompId;
      }
    }
  }

  setLocalStorage("teamDataManage", manageTeamData);
  return { teamData: manageTeamData, updatedFormations: formations };
}

const createTeamAddPlayer = (
  teamData,
  skillIdentifier,
  positionIndex,
  playerObj,
  skillId,
  maxPos,
  skillFilters,
  errorObj
) => {
  let playerID = playerObj.Id;
  let indexOfScroll = 0;
  let playerCountInSkill = filter(teamData[skillId], function (O) {
    return O.id !== null;
  }).length;
  let playerCountInBench = filter(teamData[0], function (O) {
    return O.id !== null && +O.skill === +skillId;
  }).length;
  if (playerCountInSkill + playerCountInBench < maxPos) {
    let playersPerTeamCountExceeded = isValidateByMaxTeamPlayer(
      teamData,
      playerObj,
      teamData.max_playerPerTeam
    );
    let state = playersPerTeamCountExceeded.state;
    if (playersPerTeamCountExceeded.status) {
      //check if next highlight position is avail
      let currentHighLightPosition = getHighLightFromteam(teamData);
      if (
        !isEmpty(currentHighLightPosition) &&
        playerObj.Skill == currentHighLightPosition.skill
      ) {
        teamData.budget = +teamData.budget - +playerObj.Value;
        indexOfScroll = currentHighLightPosition.rowIndex;
        teamData[currentHighLightPosition.rowIndex][
          currentHighLightPosition.playerIndex
        ] = {
          id: playerID,
          details: playerObj,
          isBench: +skillIdentifier === 0,
          isHighlighted: false,
          isCaptain: false,
          skill: skillId,
        };
        teamData.playerCount += 1;
        teamData.playersInTeam.push(playerID);
        updatePropInTeam(teamData, "isHighlighted", false);
        teamData.highlightedSkill = getNextHighLightposition(
          currentHighLightPosition.skill,
          currentHighLightPosition.playerIndex,
          teamData
        );
      } else {
        let pitchEmptyIndex = findIndex(
          teamData[playerObj.Skill],
          function (player) {
            return player.id == null;
          }
        );
        indexOfScroll = playerObj.Skill;
        if (pitchEmptyIndex > -1) {
          teamData.budget = +teamData.budget - +playerObj.Value;
          teamData[playerObj.Skill][pitchEmptyIndex] = {
            id: playerID,
            details: playerObj,
            isBench: +skillIdentifier === 0,
            isHighlighted: false,
            isCaptain: false,
            skill: skillId,
          };
          teamData.playerCount += 1;
          teamData.playersInTeam.push(playerID);
          updatePropInTeam(teamData, "isHighlighted", false);
          if (skillFilters.length == 1) {
            // show the player the next highlight position
            teamData.highlightedSkill = getNextHighLightposition(
              playerObj.Skill,
              pitchEmptyIndex,
              teamData
            );
          } else {
            teamData.highlightedSkill = getNextHighLightposition(
              playerObj.Skill,
              pitchEmptyIndex,
              teamData,
              skillFilters
            );
          }
        } else {
          //cjheck for row 0 and index is available
          let benchEmptyIndex = findIndex(teamData[0], function (player) {
            return player.id == null && player.skill == playerObj.Skill;
          });
          indexOfScroll = benchEmptyIndex;
          if (benchEmptyIndex > -1) {
            teamData.budget = +teamData.budget - +playerObj.Value;
            teamData[0][benchEmptyIndex] = {
              id: playerID,
              details: playerObj,
              isBench: +skillIdentifier === 0,
              isHighlighted: false,
              isCaptain: false,
              skill: skillId,
            };
            teamData.playerCount += 1;
            teamData.playersInTeam.push(playerID);
            updatePropInTeam(teamData, "isHighlighted", false);
            teamData.highlightedSkill = {
              skill: playerObj.Skill,
              rowIndex: 0,
              playerIndex: benchEmptyIndex,
            };
          } else {
            // all is full
          }
        }
      }
      // makeJerseyAnimate(indexOfScroll);
    }
    if (state === "ok") {
      errorObj.playersPerTeamCountExceeded = false;
      errorObj.team = null;
      errorObj.Teamid = playerObj.TeamId;
    } else if (state === "exceed") {
      errorObj.playersPerTeamCountExceeded = true;
      errorObj.team = playerObj.TeamName;
      errorObj.Teamid = playerObj.TeamId;
      errorObj.teamShrt = playerObj.TeamShortCode;
    } else if (state === "level") {
      errorObj.playersPerTeamCountExceeded = true;
      errorObj.team = playerObj.TeamName;
      errorObj.Teamid = playerObj.TeamId;
      errorObj.teamShrt = playerObj.TeamShortCode;
    }
    errorObj.state = state;
  }
  setLocalStorage("teamData", teamData);

  return {
    teamDATA: teamData,
    errorOBJ: errorObj,
  };
};

const createTeamRemovePlayer = (
  teamData,
  skillIdentifier,
  positionIndex,
  playerObj,
  skillId
) => {
  let value = 0;

  if (playerObj.Id && playerObj.Value) {
    value = playerObj.Value;
  } else {
    if (playerObj.Value) {
      value = playerObj.Value;
    }
  }
  teamData.budget = +teamData.budget + +value;
  let wasCaptain = teamData[skillIdentifier][positionIndex].isCaptain;

  teamData[skillIdentifier][positionIndex] = {
    id: null,
    details: {},
    isBench: +skillIdentifier === 0,
    isHighlighted: false,
    isCaptain: false,
    skill: skillId,
  };
  teamData.playerCount -= 1;
  let playerIndex = teamData.playersInTeam.indexOf(playerObj.Id);
  teamData.playersInTeam.splice(playerIndex, 1);
  let lastHighlightedPosition = getHighLightFromteam(teamData);
  updatePropInTeam(teamData, "isHighlighted", false);
  wasCaptain && (teamData.captainID = null);
  if (!isEmpty(lastHighlightedPosition)) {
    teamData.highlightedSkill = getNextPositionToHighlight(
      teamData,
      skillIdentifier,
      positionIndex
    );
  } else {
    teamData.highlightedSkill = {
      skill: skillIdentifier,
      rowIndex: skillIdentifier,
      playerIndex: positionIndex,
    };
  }
  return {
    teamDATA: teamData,
  };
};

const manageTeamAddPlayer = (
  teamData,
  newRowIndex,
  positionIndex,
  playerObj,
  manageTeamRawData,
  skillId,
  configObj
) => {
  let errorObj = {
    playersPerSkillCountExceeded: false,
    playersPerTeamCountExceeded: false,
    skill: null,
    team: null,
  };
  let indexOfScroll = 0;
  let playerCountInSkill = filter(teamData[skillId], function (O) {
    return O.id !== null;
  }).length;
  let playerCountInBench = filter(teamData[0], function (O) {
    return O.id !== null && O.skill === skillId;
  }).length;

  if (
    playerCountInSkill + playerCountInBench <
    configObj.EnumMaxPositionNos[skillId]
  ) {
    let playersPerTeamCountExceeded = isValidateByMaxTeamPlayer(
      teamData,
      playerObj,
      teamData.max_playerPerTeam
    );
    let state = playersPerTeamCountExceeded.state;

    if (playersPerTeamCountExceeded.status) {
      teamData.budget = +teamData.budget - +playerObj.Value;
      indexOfScroll = newRowIndex;
      let wasCaptain = teamData[newRowIndex][positionIndex].isCaptain;
      let playerObjFound = teamData[newRowIndex][positionIndex];
      let playerID = playerObj.Id;
      playerObjFound.id = playerID;
      playerObjFound.details = playerObj;
      teamData.playerCount += 1;

      teamData.playersInTeam.push(playerID);
      updatePropInTeam(teamData, "isHighlighted", false);
      wasCaptain && (teamData.captainID = playerID);
      let isPlayerInRemovedKey =
        manageTeamRawData.playersInTeam.indexOf(playerID) > -1;
      if (isPlayerInRemovedKey) {
        let oldPosition = getPlayerPosition(playerID, manageTeamRawData);
        let oldRowIndex = oldPosition.rowIndex;
        let oldPositionIndex = oldPosition.playerIndex;
        let playerFromOldPosition = JSON.parse(
          JSON.stringify(teamData[oldRowIndex][oldPositionIndex])
        );
        let playerFromNewPosition = JSON.parse(
          JSON.stringify(teamData[newRowIndex][positionIndex])
        );
        /*Assigning player from old position to new position*/
        teamData[newRowIndex][positionIndex].id = playerFromOldPosition.id;
        teamData[newRowIndex][positionIndex].details = JSON.parse(
          JSON.stringify(playerFromOldPosition.details)
        );
        /*Assigning player from new position to old position*/
        teamData[oldRowIndex][oldPositionIndex].id = playerFromNewPosition.id;
        teamData[oldRowIndex][oldPositionIndex].details = JSON.parse(
          JSON.stringify(playerFromNewPosition.details)
        );
        if (
          oldRowIndex > -1 &&
          oldPositionIndex > -1 &&
          oldRowIndex != undefined &&
          oldPositionIndex != undefined
        ) {
          teamData.highlightedSkill = {
            skill: playerObj.Skill,
            rowIndex: oldRowIndex,
            playerIndex: oldPositionIndex,
          };
        } else {
          teamData.highlightedSkill = {
            skill: playerObj.Skill,
            rowIndex: newRowIndex,
            playerIndex: positionIndex,
          };
        }
      }
      // teamData.highlightedSkill = getNextPositionToHighlight(teamData, rowIndex, ++playerIndex);
    }
    if (state === "ok") {
      errorObj.playersPerTeamCountExceeded = false;
      errorObj.team = null;
      errorObj.Teamid = playerObj.TeamId;
    } else if (state === "exceed") {
      errorObj.playersPerTeamCountExceeded = true;
      errorObj.team = playerObj.TeamName;
      errorObj.Teamid = playerObj.TeamId;
      errorObj.teamShrt = playerObj.TeamShortCode;
    } else if (state === "level") {
      errorObj.playersPerTeamCountExceeded = true;
      errorObj.team = playerObj.TeamName;
      errorObj.Teamid = playerObj.TeamId;
      errorObj.teamShrt = playerObj.TeamShortCode;
    }
    errorObj.state = state;
  }
  // makeJerseyAnimate(indexOfScroll);
  return {
    teamDATA: teamData,
    errorOBJ: errorObj,
  };
};

const manageTeamRemovePlayer = (
  teamData,
  rowIndex,
  positionIndex,
  playerID,
  pObjValue,
  pObjSkill
) => {
  teamData.budget = +teamData.budget + pObjValue;
  let wasCaptain = teamData[rowIndex][positionIndex].isCaptain;
  let playerObjFound = teamData[rowIndex][positionIndex];
  playerObjFound.id = null;
  playerObjFound.details = {};
  teamData.playerCount -= 1;
  let playerIndex = teamData.playersInTeam.indexOf(playerID);
  teamData.playersInTeam.splice(playerIndex, 1);
  updatePropInTeam(teamData, "isHighlighted", false);
  wasCaptain && (teamData.captainID = null);
  // teamData.highlightedSkill = getNextPositionToHighlight(teamData, rowIndex, positionIndex);
  teamData.highlightedSkill = {
    skill: pObjSkill,
    rowIndex: rowIndex,
    playerIndex: positionIndex,
  };
  return {
    teamDATA: teamData,
  };
};

/**
 *This is used for checking no of player from one team
 */
export function isValidateByMaxTeamPlayer(teamDataP, objPlayer, jMaxTeamCount) {
  let totalCount = orderToScan.reduce((initialValue, position) => {
    initialValue += teamDataP[position].filter(
      (playerObj) =>
        playerObj.id && playerObj.details.TeamId === objPlayer.TeamId
    ).length;
    return initialValue;
  }, 0);
  if (totalCount === jMaxTeamCount - 1) {
    return { status: true, state: "level" };
  } else if (totalCount >= jMaxTeamCount) {
    return { status: false, state: "exceed" };
  } else {
    return { status: true, state: "ok" };
  }
}

function getHighLightFromteam(teamData) {
  let playerPosition = {};
  find(orderToScan, (position) => {
    find(teamData[position], (player, index) => {
      if (player.isHighlighted === true) {
        // playerPosition = { skill: player.skill, rowIndex: position, playerIndex: index };
        playerPosition = {
          skill: player.skill,
          rowIndex: position,
          playerIndex: index,
        };
      }
    });
  });
  return playerPosition;
}

function getNextHighLightposition(
  skill,
  currentIndex,
  teamData,
  skillFilter,
  row
) {
  if (skillFilter && skillFilter.length > 1) {
    if (row === 0) {
      let currentPlayerZeroIndex = teamData[row][currentIndex];
      return {
        skill: currentPlayerZeroIndex.skill,
        rowIndex: row,
        playerIndex: currentPlayerZeroIndex,
      };
    } else {
      let currentPlayerPitchIndex = teamData[skill][currentIndex];
      return {
        skill: currentPlayerPitchIndex.skill,
        rowIndex: currentPlayerPitchIndex.skill,
        playerIndex: currentPlayerPitchIndex,
      };
    }
  } else {
    let possiblePlayer = teamData[skill][currentIndex + 1];
    // also check if row position is all filled
    let oddSequenceFillerPlayer = find(teamData[skill], function (player) {
      return player.id == null;
    });
    if (possiblePlayer && possiblePlayer.id == null) {
      possiblePlayer.isHighlighted = true;
      return {
        skill: possiblePlayer.skill,
        rowIndex: possiblePlayer.skill,
        playerIndex: currentIndex + 1,
      };
    } else if (oddSequenceFillerPlayer && oddSequenceFillerPlayer.id == null) {
      oddSequenceFillerPlayer.isHighlighted = true;
      return {
        skill: oddSequenceFillerPlayer.skill,
        rowIndex: oddSequenceFillerPlayer.skill,
        playerIndex: currentIndex + 1,
      };
    } else {
      //also check if player available in bench
      var benchEmptyIndex = findIndex(teamData[0], function (player) {
        return player.id == null && player.skill == skill;
      });
      if (benchEmptyIndex > -1) {
        let bechPlayer = teamData[0][benchEmptyIndex];
        bechPlayer.isHighlighted = true;
        return {
          skill: bechPlayer.skill,
          rowIndex: 0,
          playerIndex: benchEmptyIndex,
        };
      }
    }
  }
}

function getNextPositionToHighlight(teamData, rowIndex, newPlayerIndex) {
  const isAllTeamFilled = () =>
    every(orderToScan, (row) =>
      every(teamData[row], (player) => player.id !== null)
    );
  const possibleRow = teamData[rowIndex];
  if (possibleRow) {
    const possiblePlayer = possibleRow[newPlayerIndex];
    if (possiblePlayer) {
      if (possiblePlayer.id === null) {
        possiblePlayer.isHighlighted = true;
        return {
          skill: possiblePlayer.skill,
          rowIndex: rowIndex,
          playerIndex: newPlayerIndex,
        };
      } else {
        if (isPositionAllFilled(teamData, rowIndex)) {
          return getUpdatedPosition(teamData, rowIndex);
        } else {
          return getNextPositionToHighlight(
            teamData,
            rowIndex,
            ++newPlayerIndex
          );
        }
      }
    } else {
      if (isPositionAllFilled(teamData, rowIndex)) {
        return getUpdatedPosition(teamData, rowIndex);
      } else {
        if (rowIndex != 0) {
          return getNextPositionToHighlight(teamData, rowIndex, 0);
        }
      }
    }
  } else {
    if (isAllTeamFilled()) {
      return {};
    } else {
      return getNextPositionToHighlight(teamData, 4, 0);
    }
  }
}

function getUpdatedPosition(teamData, rowIndex) {
  //get the skill
  let skill = teamData[rowIndex][0].skill;
  let highlightIndex = "";
  if (teamData[0]) {
    highlightIndex = findIndex(teamData[0], function (plyObj) {
      return plyObj.skill == skill && plyObj.id == null;
    });
    if (highlightIndex > -1) {
      return getNextPositionToHighlight(teamData, 0, highlightIndex);
    }
  }
}

function isPositionAllFilled(teamData, row) {
  return teamData[row].every((player) => {
    return player.id !== null;
  });
}

// returns whether forward player or defender etc
export function getPlayerPosition(playerID, teamData) {
  let playerPosition = {};
  find(orderToScan, (position) => {
    return find(teamData[position], (player, index) => {
      if (player.details.Id === playerID) {
        playerPosition = {
          skill: player.skill,
          rowIndex: position,
          playerIndex: index,
          player,
        };
        return true;
      }
      return false;
    });
  });
  return playerPosition;
}

export function disablePlayer(teamData, player, maxPlayerCount) {
  if (Array.isArray(teamData[0] ? teamData[0] : {})) {
    const orderToScan = ["4", "3", "2", "1", "0"];
    let showDisabled = true;
    //check max team condition
    const jMaxTeamCount = maxPlayerCount ? maxPlayerCount : 3;
    let totalCount = orderToScan.reduce((initialValue, position) => {
      initialValue += filter(
        teamData[position],
        (playerObj) =>
          playerObj.id && playerObj.details.TeamId === player.TeamId
      ).length;
      return initialValue;
    }, 0);
    if (totalCount >= jMaxTeamCount) {
      //also check if player in team
      for (var i = 0; i < orderToScan.length; i++) {
        for (var j = 0; j < teamData[i].length; j++) {
          if (teamData[i][j].id == player.Id) {
            return false;
          }
        }
      }
      return true;
    }

    for (var i = 0; i < orderToScan.length; i++) {
      for (var j = 0; j < teamData[i].length; j++) {
        if (teamData[i][j].id == null && teamData[i][j].skill == player.skill) {
          showDisabled = false;
        }
        if (teamData[i][j].id == player.Id) {
          showDisabled = false;
        }
      }
    }

    //check if player is in team

    return showDisabled;
  } else {
    return false;
  }
}

export function sortBy(data, key, order = "DESC", isPlayerRecomendation) {
  let sortableData = data;
  // sortableData = filter(sortableData,item => item.isActive && item);
  if (order === "DESC") {
    sortableData = sortableData.sort((obj1, obj2) => {
      const valueA = +obj1[key];
      const valueB = +obj2[key];
      if (valueA > valueB) return -1;
      if (valueA < valueB) return 1;
      return 0;
    });
  } else if (order === "ASC") {
    sortableData = sortableData.sort((obj1, obj2) => {
      const valueA = +obj1[key];
      const valueB = +obj2[key];
      if (valueA < valueB) return -1;
      if (valueA > valueB) return 1;
      return 0;
    });
  }
  let filtereddata = [];

  if (isPlayerRecomendation) {
    sortableData.map(function (player) {
      if (
        player[key] == "" ||
        player[key] == null ||
        player[key] == undefined ||
        player[key] == "0"
      ) {
      } else {
        filtereddata.push(player);
      }
    });
  }

  if (isPlayerRecomendation) {
    sortableData = filtereddata;
  }

  if (key == "playerRecomendationdDefault") {
    sortableData = sortableData;
  }

  return sortableData;
}

export function searchBy(n, searchByArray, searchStr) {
  /* eslint-disable */
  const Latinise = {};
  Latinise.latin_map = {
    Á: "A",
    Ă: "A",
    Ắ: "A",
    Ặ: "A",
    Ằ: "A",
    Ẳ: "A",
    Ẵ: "A",
    Ǎ: "A",
    Â: "A",
    Ấ: "A",
    Ậ: "A",
    Ầ: "A",
    Ẩ: "A",
    Ẫ: "A",
    Ä: "A",
    Ǟ: "A",
    Ȧ: "A",
    Ǡ: "A",
    Ạ: "A",
    Ȁ: "A",
    À: "A",
    Ả: "A",
    Ȃ: "A",
    Ā: "A",
    Ą: "A",
    Å: "A",
    Ǻ: "A",
    Ḁ: "A",
    Ⱥ: "A",
    Ã: "A",
    Ꜳ: "AA",
    Æ: "AE",
    Ǽ: "AE",
    Ǣ: "AE",
    Ꜵ: "AO",
    Ꜷ: "AU",
    Ꜹ: "AV",
    Ꜻ: "AV",
    Ꜽ: "AY",
    Ḃ: "B",
    Ḅ: "B",
    Ɓ: "B",
    Ḇ: "B",
    Ƀ: "B",
    Ƃ: "B",
    Ć: "C",
    Č: "C",
    Ç: "C",
    Ḉ: "C",
    Ĉ: "C",
    Ċ: "C",
    Ƈ: "C",
    Ȼ: "C",
    Ď: "D",
    Ḑ: "D",
    Ḓ: "D",
    Ḋ: "D",
    Ḍ: "D",
    Ɗ: "D",
    Ḏ: "D",
    ǲ: "D",
    ǅ: "D",
    Đ: "D",
    Ƌ: "D",
    Ǳ: "DZ",
    Ǆ: "DZ",
    É: "E",
    Ĕ: "E",
    Ě: "E",
    Ȩ: "E",
    Ḝ: "E",
    Ê: "E",
    Ế: "E",
    Ệ: "E",
    Ề: "E",
    Ể: "E",
    Ễ: "E",
    Ḙ: "E",
    Ë: "E",
    Ė: "E",
    Ẹ: "E",
    Ȅ: "E",
    È: "E",
    Ẻ: "E",
    Ȇ: "E",
    Ē: "E",
    Ḗ: "E",
    Ḕ: "E",
    Ę: "E",
    Ɇ: "E",
    Ẽ: "E",
    Ḛ: "E",
    Ꝫ: "ET",
    Ḟ: "F",
    Ƒ: "F",
    Ǵ: "G",
    Ğ: "G",
    Ǧ: "G",
    Ģ: "G",
    Ĝ: "G",
    Ġ: "G",
    Ɠ: "G",
    Ḡ: "G",
    Ǥ: "G",
    Ḫ: "H",
    Ȟ: "H",
    Ḩ: "H",
    Ĥ: "H",
    Ⱨ: "H",
    Ḧ: "H",
    Ḣ: "H",
    Ḥ: "H",
    Ħ: "H",
    Í: "I",
    Ĭ: "I",
    Ǐ: "I",
    Î: "I",
    Ï: "I",
    Ḯ: "I",
    İ: "I",
    Ị: "I",
    Ȉ: "I",
    Ì: "I",
    Ỉ: "I",
    Ȋ: "I",
    Ī: "I",
    Į: "I",
    Ɨ: "I",
    Ĩ: "I",
    Ḭ: "I",
    Ꝺ: "D",
    Ꝼ: "F",
    Ᵹ: "G",
    Ꞃ: "R",
    Ꞅ: "S",
    Ꞇ: "T",
    Ꝭ: "IS",
    Ĵ: "J",
    Ɉ: "J",
    Ḱ: "K",
    Ǩ: "K",
    Ķ: "K",
    Ⱪ: "K",
    Ꝃ: "K",
    Ḳ: "K",
    Ƙ: "K",
    Ḵ: "K",
    Ꝁ: "K",
    Ꝅ: "K",
    Ĺ: "L",
    Ƚ: "L",
    Ľ: "L",
    Ļ: "L",
    Ḽ: "L",
    Ḷ: "L",
    Ḹ: "L",
    Ⱡ: "L",
    Ꝉ: "L",
    Ḻ: "L",
    Ŀ: "L",
    Ɫ: "L",
    ǈ: "L",
    Ł: "L",
    Ǉ: "LJ",
    Ḿ: "M",
    Ṁ: "M",
    Ṃ: "M",
    Ɱ: "M",
    Ń: "N",
    Ň: "N",
    Ņ: "N",
    Ṋ: "N",
    Ṅ: "N",
    Ṇ: "N",
    Ǹ: "N",
    Ɲ: "N",
    Ṉ: "N",
    Ƞ: "N",
    ǋ: "N",
    Ñ: "N",
    Ǌ: "NJ",
    Ó: "O",
    Ŏ: "O",
    Ǒ: "O",
    Ô: "O",
    Ố: "O",
    Ộ: "O",
    Ồ: "O",
    Ổ: "O",
    Ỗ: "O",
    Ö: "O",
    Ȫ: "O",
    Ȯ: "O",
    Ȱ: "O",
    Ọ: "O",
    Ő: "O",
    Ȍ: "O",
    Ò: "O",
    Ỏ: "O",
    Ơ: "O",
    Ớ: "O",
    Ợ: "O",
    Ờ: "O",
    Ở: "O",
    Ỡ: "O",
    Ȏ: "O",
    Ꝋ: "O",
    Ꝍ: "O",
    Ō: "O",
    Ṓ: "O",
    Ṑ: "O",
    Ɵ: "O",
    Ǫ: "O",
    Ǭ: "O",
    Ø: "O",
    Ǿ: "O",
    Õ: "O",
    Ṍ: "O",
    Ṏ: "O",
    Ȭ: "O",
    Ƣ: "OI",
    Ꝏ: "OO",
    Ɛ: "E",
    Ɔ: "O",
    Ȣ: "OU",
    Ṕ: "P",
    Ṗ: "P",
    Ꝓ: "P",
    Ƥ: "P",
    Ꝕ: "P",
    Ᵽ: "P",
    Ꝑ: "P",
    Ꝙ: "Q",
    Ꝗ: "Q",
    Ŕ: "R",
    Ř: "R",
    Ŗ: "R",
    Ṙ: "R",
    Ṛ: "R",
    Ṝ: "R",
    Ȑ: "R",
    Ȓ: "R",
    Ṟ: "R",
    Ɍ: "R",
    Ɽ: "R",
    Ꜿ: "C",
    Ǝ: "E",
    Ś: "S",
    Ṥ: "S",
    Š: "S",
    Ṧ: "S",
    Ş: "S",
    Ŝ: "S",
    Ș: "S",
    Ṡ: "S",
    Ṣ: "S",
    Ṩ: "S",
    Ť: "T",
    Ţ: "T",
    Ṱ: "T",
    Ț: "T",
    Ⱦ: "T",
    Ṫ: "T",
    Ṭ: "T",
    Ƭ: "T",
    Ṯ: "T",
    Ʈ: "T",
    Ŧ: "T",
    Ɐ: "A",
    Ꞁ: "L",
    Ɯ: "M",
    Ʌ: "V",
    Ꜩ: "TZ",
    Ú: "U",
    Ŭ: "U",
    Ǔ: "U",
    Û: "U",
    Ṷ: "U",
    Ü: "U",
    Ǘ: "U",
    Ǚ: "U",
    Ǜ: "U",
    Ǖ: "U",
    Ṳ: "U",
    Ụ: "U",
    Ű: "U",
    Ȕ: "U",
    Ù: "U",
    Ủ: "U",
    Ư: "U",
    Ứ: "U",
    Ự: "U",
    Ừ: "U",
    Ử: "U",
    Ữ: "U",
    Ȗ: "U",
    Ū: "U",
    Ṻ: "U",
    Ų: "U",
    Ů: "U",
    Ũ: "U",
    Ṹ: "U",
    Ṵ: "U",
    Ꝟ: "V",
    Ṿ: "V",
    Ʋ: "V",
    Ṽ: "V",
    Ꝡ: "VY",
    Ẃ: "W",
    Ŵ: "W",
    Ẅ: "W",
    Ẇ: "W",
    Ẉ: "W",
    Ẁ: "W",
    Ⱳ: "W",
    Ẍ: "X",
    Ẋ: "X",
    Ý: "Y",
    Ŷ: "Y",
    Ÿ: "Y",
    Ẏ: "Y",
    Ỵ: "Y",
    Ỳ: "Y",
    Ƴ: "Y",
    Ỷ: "Y",
    Ỿ: "Y",
    Ȳ: "Y",
    Ɏ: "Y",
    Ỹ: "Y",
    Ź: "Z",
    Ž: "Z",
    Ẑ: "Z",
    Ⱬ: "Z",
    Ż: "Z",
    Ẓ: "Z",
    Ȥ: "Z",
    Ẕ: "Z",
    Ƶ: "Z",
    Ĳ: "IJ",
    Œ: "OE",
    ᴀ: "A",
    ᴁ: "AE",
    ʙ: "B",
    ᴃ: "B",
    ᴄ: "C",
    ᴅ: "D",
    ᴇ: "E",
    ꜰ: "F",
    ɢ: "G",
    ʛ: "G",
    ʜ: "H",
    ɪ: "I",
    ʁ: "R",
    ᴊ: "J",
    ᴋ: "K",
    ʟ: "L",
    ᴌ: "L",
    ᴍ: "M",
    ɴ: "N",
    ᴏ: "O",
    ɶ: "OE",
    ᴐ: "O",
    ᴕ: "OU",
    ᴘ: "P",
    ʀ: "R",
    ᴎ: "N",
    ᴙ: "R",
    ꜱ: "S",
    ᴛ: "T",
    ⱻ: "E",
    ᴚ: "R",
    ᴜ: "U",
    ᴠ: "V",
    ᴡ: "W",
    ʏ: "Y",
    ᴢ: "Z",
    á: "a",
    ă: "a",
    ắ: "a",
    ặ: "a",
    ằ: "a",
    ẳ: "a",
    ẵ: "a",
    ǎ: "a",
    â: "a",
    ấ: "a",
    ậ: "a",
    ầ: "a",
    ẩ: "a",
    ẫ: "a",
    ä: "a",
    ǟ: "a",
    ȧ: "a",
    ǡ: "a",
    ạ: "a",
    ȁ: "a",
    à: "a",
    ả: "a",
    ȃ: "a",
    ā: "a",
    ą: "a",
    ᶏ: "a",
    ẚ: "a",
    å: "a",
    ǻ: "a",
    ḁ: "a",
    ⱥ: "a",
    ã: "a",
    ꜳ: "aa",
    æ: "ae",
    ǽ: "ae",
    ǣ: "ae",
    ꜵ: "ao",
    ꜷ: "au",
    ꜹ: "av",
    ꜻ: "av",
    ꜽ: "ay",
    ḃ: "b",
    ḅ: "b",
    ɓ: "b",
    ḇ: "b",
    ᵬ: "b",
    ᶀ: "b",
    ƀ: "b",
    ƃ: "b",
    ɵ: "o",
    ć: "c",
    č: "c",
    ç: "c",
    ḉ: "c",
    ĉ: "c",
    ɕ: "c",
    ċ: "c",
    ƈ: "c",
    ȼ: "c",
    ď: "d",
    ḑ: "d",
    ḓ: "d",
    ȡ: "d",
    ḋ: "d",
    ḍ: "d",
    ɗ: "d",
    ᶑ: "d",
    ḏ: "d",
    ᵭ: "d",
    ᶁ: "d",
    đ: "d",
    ɖ: "d",
    ƌ: "d",
    ı: "i",
    ȷ: "j",
    ɟ: "j",
    ʄ: "j",
    ǳ: "dz",
    ǆ: "dz",
    é: "e",
    ĕ: "e",
    ě: "e",
    ȩ: "e",
    ḝ: "e",
    ê: "e",
    ế: "e",
    ệ: "e",
    ề: "e",
    ể: "e",
    ễ: "e",
    ḙ: "e",
    ë: "e",
    ė: "e",
    ẹ: "e",
    ȅ: "e",
    è: "e",
    ẻ: "e",
    ȇ: "e",
    ē: "e",
    ḗ: "e",
    ḕ: "e",
    ⱸ: "e",
    ę: "e",
    ᶒ: "e",
    ɇ: "e",
    ẽ: "e",
    ḛ: "e",
    ꝫ: "et",
    ḟ: "f",
    ƒ: "f",
    ᵮ: "f",
    ᶂ: "f",
    ǵ: "g",
    ğ: "g",
    ǧ: "g",
    ģ: "g",
    ĝ: "g",
    ġ: "g",
    ɠ: "g",
    ḡ: "g",
    ᶃ: "g",
    ǥ: "g",
    ḫ: "h",
    ȟ: "h",
    ḩ: "h",
    ĥ: "h",
    ⱨ: "h",
    ḧ: "h",
    ḣ: "h",
    ḥ: "h",
    ɦ: "h",
    ẖ: "h",
    ħ: "h",
    ƕ: "hv",
    í: "i",
    ĭ: "i",
    ǐ: "i",
    î: "i",
    ï: "i",
    ḯ: "i",
    ị: "i",
    ȉ: "i",
    ì: "i",
    ỉ: "i",
    ȋ: "i",
    ī: "i",
    į: "i",
    ᶖ: "i",
    ɨ: "i",
    ĩ: "i",
    ḭ: "i",
    ꝺ: "d",
    ꝼ: "f",
    ᵹ: "g",
    ꞃ: "r",
    ꞅ: "s",
    ꞇ: "t",
    ꝭ: "is",
    ǰ: "j",
    ĵ: "j",
    ʝ: "j",
    ɉ: "j",
    ḱ: "k",
    ǩ: "k",
    ķ: "k",
    ⱪ: "k",
    ꝃ: "k",
    ḳ: "k",
    ƙ: "k",
    ḵ: "k",
    ᶄ: "k",
    ꝁ: "k",
    ꝅ: "k",
    ĺ: "l",
    ƚ: "l",
    ɬ: "l",
    ľ: "l",
    ļ: "l",
    ḽ: "l",
    ȴ: "l",
    ḷ: "l",
    ḹ: "l",
    ⱡ: "l",
    ꝉ: "l",
    ḻ: "l",
    ŀ: "l",
    ɫ: "l",
    ᶅ: "l",
    ɭ: "l",
    ł: "l",
    ǉ: "lj",
    ſ: "s",
    ẜ: "s",
    ẛ: "s",
    ẝ: "s",
    ḿ: "m",
    ṁ: "m",
    ṃ: "m",
    ɱ: "m",
    ᵯ: "m",
    ᶆ: "m",
    ń: "n",
    ň: "n",
    ņ: "n",
    ṋ: "n",
    ȵ: "n",
    ṅ: "n",
    ṇ: "n",
    ǹ: "n",
    ɲ: "n",
    ṉ: "n",
    ƞ: "n",
    ᵰ: "n",
    ᶇ: "n",
    ɳ: "n",
    ñ: "n",
    ǌ: "nj",
    ó: "o",
    ŏ: "o",
    ǒ: "o",
    ô: "o",
    ố: "o",
    ộ: "o",
    ồ: "o",
    ổ: "o",
    ỗ: "o",
    ö: "o",
    ȫ: "o",
    ȯ: "o",
    ȱ: "o",
    ọ: "o",
    ő: "o",
    ȍ: "o",
    ò: "o",
    ỏ: "o",
    ơ: "o",
    ớ: "o",
    ợ: "o",
    ờ: "o",
    ở: "o",
    ỡ: "o",
    ȏ: "o",
    ꝋ: "o",
    ꝍ: "o",
    ⱺ: "o",
    ō: "o",
    ṓ: "o",
    ṑ: "o",
    ǫ: "o",
    ǭ: "o",
    ø: "o",
    ǿ: "o",
    õ: "o",
    ṍ: "o",
    ṏ: "o",
    ȭ: "o",
    ƣ: "oi",
    ꝏ: "oo",
    ɛ: "e",
    ᶓ: "e",
    ɔ: "o",
    ᶗ: "o",
    ȣ: "ou",
    ṕ: "p",
    ṗ: "p",
    ꝓ: "p",
    ƥ: "p",
    ᵱ: "p",
    ᶈ: "p",
    ꝕ: "p",
    ᵽ: "p",
    ꝑ: "p",
    ꝙ: "q",
    ʠ: "q",
    ɋ: "q",
    ꝗ: "q",
    ŕ: "r",
    ř: "r",
    ŗ: "r",
    ṙ: "r",
    ṛ: "r",
    ṝ: "r",
    ȑ: "r",
    ɾ: "r",
    ᵳ: "r",
    ȓ: "r",
    ṟ: "r",
    ɼ: "r",
    ᵲ: "r",
    ᶉ: "r",
    ɍ: "r",
    ɽ: "r",
    ↄ: "c",
    ꜿ: "c",
    ɘ: "e",
    ɿ: "r",
    ś: "s",
    ṥ: "s",
    š: "s",
    ṧ: "s",
    ş: "s",
    ŝ: "s",
    ș: "s",
    ṡ: "s",
    ṣ: "s",
    ṩ: "s",
    ʂ: "s",
    ᵴ: "s",
    ᶊ: "s",
    ȿ: "s",
    ɡ: "g",
    ᴑ: "o",
    ᴓ: "o",
    ᴝ: "u",
    ť: "t",
    ţ: "t",
    ṱ: "t",
    ț: "t",
    ȶ: "t",
    ẗ: "t",
    ⱦ: "t",
    ṫ: "t",
    ṭ: "t",
    ƭ: "t",
    ṯ: "t",
    ᵵ: "t",
    ƫ: "t",
    ʈ: "t",
    ŧ: "t",
    ᵺ: "th",
    ɐ: "a",
    ᴂ: "ae",
    ǝ: "e",
    ᵷ: "g",
    ɥ: "h",
    ʮ: "h",
    ʯ: "h",
    ᴉ: "i",
    ʞ: "k",
    ꞁ: "l",
    ɯ: "m",
    ɰ: "m",
    ᴔ: "oe",
    ɹ: "r",
    ɻ: "r",
    ɺ: "r",
    ⱹ: "r",
    ʇ: "t",
    ʌ: "v",
    ʍ: "w",
    ʎ: "y",
    ꜩ: "tz",
    ú: "u",
    ŭ: "u",
    ǔ: "u",
    û: "u",
    ṷ: "u",
    ü: "u",
    ǘ: "u",
    ǚ: "u",
    ǜ: "u",
    ǖ: "u",
    ṳ: "u",
    ụ: "u",
    ű: "u",
    ȕ: "u",
    ù: "u",
    ủ: "u",
    ư: "u",
    ứ: "u",
    ự: "u",
    ừ: "u",
    ử: "u",
    ữ: "u",
    ȗ: "u",
    ū: "u",
    ṻ: "u",
    ų: "u",
    ᶙ: "u",
    ů: "u",
    ũ: "u",
    ṹ: "u",
    ṵ: "u",
    ᵫ: "ue",
    ꝸ: "um",
    ⱴ: "v",
    ꝟ: "v",
    ṿ: "v",
    ʋ: "v",
    ᶌ: "v",
    ⱱ: "v",
    ṽ: "v",
    ꝡ: "vy",
    ẃ: "w",
    ŵ: "w",
    ẅ: "w",
    ẇ: "w",
    ẉ: "w",
    ẁ: "w",
    ⱳ: "w",
    ẘ: "w",
    ẍ: "x",
    ẋ: "x",
    ᶍ: "x",
    ý: "y",
    ŷ: "y",
    ÿ: "y",
    ẏ: "y",
    ỵ: "y",
    ỳ: "y",
    ƴ: "y",
    ỷ: "y",
    ỿ: "y",
    ȳ: "y",
    ẙ: "y",
    ɏ: "y",
    ỹ: "y",
    ź: "z",
    ž: "z",
    ẑ: "z",
    ʑ: "z",
    ⱬ: "z",
    ż: "z",
    ẓ: "z",
    ȥ: "z",
    ẕ: "z",
    ᵶ: "z",
    ᶎ: "z",
    ʐ: "z",
    ƶ: "z",
    ɀ: "z",
    ﬀ: "ff",
    ﬃ: "ffi",
    ﬄ: "ffl",
    ﬁ: "fi",
    ﬂ: "fl",
    ĳ: "ij",
    œ: "oe",
    ﬆ: "st",
    ₐ: "a",
    ₑ: "e",
    ᵢ: "i",
    ⱼ: "j",
    ₒ: "o",
    ᵣ: "r",
    ᵤ: "u",
    ᵥ: "v",
    ₓ: "x",
  };
  String.prototype.latinise = function () {
    return this.replace(
      /[^A-Za-z0-9\[\] ]/g,
      (a) => Latinise.latin_map[a] || a
    );
  };
  String.prototype.latinize = String.prototype.latinise;
  String.prototype.isLatin = function () {
    return this === this.latinise();
  };
  return searchByArray.some((searchBy) => {
    const d = n[searchBy].toLowerCase().latinize();
    const searchStrLatin = searchStr.toLowerCase().latinise();
    return d.indexOf(searchStrLatin) > -1;
  });
  /* eslint-disable */
}

export function filterList(playerListRaw, playerFilters, budget) {
  let sortByOption = playerFilters.sortBy;
  if (
    playerFilters.playerRecomendation[0] != config.playerRecomendationDefault
  ) {
    sortByOption = playerFilters.playerRecomendation[0];
  }
  const teamIDsToFilter = playerFilters.teamIds;

  let selectedPriceFilter = playerFilters.priceFilterObj.filter((item) =>
    playerFilters.priceFilterSelected == item.label ? true : false
  );

  if (selectedPriceFilter.length == 0) {
    selectedPriceFilter = [
      {
        id: 0,
        label: "Unlimited",
        min: 0,
        max: config.WebConfig.maxPlayerBudget,
        selected: false,
        labelTrans: "Unlimited",
      },
    ];
  }
  if (playerFilters.searchString != "") {
    const searchByPlayerList = playerListRaw.filter((player) => {
      return playerFilters.searchString
        ? searchBy(
            player,
            ["PlayerFirstName", "PlayerLastName", "DisplayName"],
            playerFilters.searchString
          )
        : true;
    });
    let sortedPlayerList = sortBy(searchByPlayerList, sortByOption);
    return sortedPlayerList;
  }

  const playerList = playerListRaw.filter((player) => {
    return (
      player.IsActive &&
      (teamIDsToFilter.length
        ? teamIDsToFilter.indexOf(player.TeamId) > -1
        : true) &&
      (selectedPriceFilter.length
        ? selectedPriceFilter.some((item) => {
            if (item.id == 0) {
              return player;
            } else if (item.id == 1) {
              // budget affordable
              return player["Value"] <= parseFloat(budget ? budget : budget);
            } else {
              return player["Value"] <= item.max;
            }
          })
        : true) &&
      (playerFilters.searchString
        ? searchBy(
            player,
            ["PlayerFirstName", "PlayerLastName"],
            playerFilters.searchString
          )
        : true)
    );
  });

  let sortedPlayerList = sortBy(playerList, sortByOption);
  let finalSorteddlist = [];
  if (
    playerFilters.skillId.length > 0 &&
    playerFilters.skillId.indexOf(0) < 0
  ) {
    if (playerFilters.searchString != "") {
      const searchByPlayerList = sortedPlayerList.filter((player) => {
        return playerFilters.searchString
          ? searchBy(
              player,
              ["PlayerFirstName", "PlayerLastName"],
              playerFilters.searchString
            )
          : true;
      });
      finalSorteddlist = searchByPlayerList;
    } else {
      finalSorteddlist = filter(sortedPlayerList, (item) => {
        return playerFilters.skillId.indexOf(item.Skill) > -1;
      });
    }
  } else {
    finalSorteddlist = sortedPlayerList;
  }

  //  //check if player status is applied
  if (sortedPlayerList.length) {
    let isSortByPlayerApplied = false;
    var playerStatusColl = [];
    for (var o = 0; o < playerFilters.playerStatus.length; o++) {
      for (var k = 0; k < sortedPlayerList.length; k++) {
        if (
          sortedPlayerList[k].pStatus == playerFilters.playerStatus[o].id &&
          playerFilters.playerStatus[o].active == true
        ) {
          let player = sortedPlayerList[k];
          //also check for the other filters applied
          if (
            player.IsActive &&
            (teamIDsToFilter.length
              ? teamIDsToFilter.indexOf(player.TeamId) > -1
              : true) &&
            (playerFilters.skillId.length
              ? playerFilters.skillId.indexOf(player.Skill) > -1 ||
                playerFilters.skillId.indexOf(0) > -1
              : true)
          ) {
            playerStatusColl.push(sortedPlayerList[k]);
          }
        }
        if (playerFilters.playerStatus[o].active == true) {
          isSortByPlayerApplied = true;
        }
      }
    }
    if (isSortByPlayerApplied) {
      finalSorteddlist = playerStatusColl;
    } else {
      finalSorteddlist = finalSorteddlist;
    }
  }

  //check if playerrecomendation filter applied then slice 20
  if (
    playerFilters.playerRecomendation[0] != config.playerRecomendationDefault
  ) {
    let sortedPlayers = sortBy(finalSorteddlist, sortByOption, "DESC", true);
    let filteredPlayers = sortedPlayers.filter((player, idx) => {
      return player[sortByOption] > 0;
    });
    return filteredPlayers; //.slice(0, config.recomendedListCount);
  } else {
    return finalSorteddlist;
  }
}

export const setDropDownHeight = function (id, liHeight, liLength) {
  // get ul height
  var ulHeight = $(id).height() ? $(id).height() : 190;
  var calLiHeight = liHeight * liLength;
  if (ulHeight > calLiHeight) {
    return { height: calLiHeight + "px" };
  } else {
    return {
      height: ulHeight + "px",
    };
  }
};

export const getFilterCount = function (filters) {
  let count = 0;
  //check sort by
  if (filters.sortBy != "totPts") {
    // count = count + 1;
  }
  //check teamIds
  if (filters.teamIds.length > 0) {
    count = count + filters.teamIds.length;
  }

  if (filters.priceFilterSelected != "") {
    count = count + 1;
  }

  if (filters.skillId.length > 0) {
    count = count + filters.skillId.length;
  }

  if (filters.sortByObj) {
    count = count + 1;
  }

  if (filters.playerRecomendation[0] != "playerRecomendationdDefault") {
    count = count + 1;
  }

  for (var i = 0; i < filters.playerStatus.length; i++) {
    if (filters.playerStatus[i].active) {
      count = count + 1;
    }
  }

  return count;
};

export function autoFill(playerList, teamData, isManageTeam) {
  teamData = JSON.parse(JSON.stringify(teamData));
  let Budget = parseFloat(teamData.budget),
    maxPerTeam = teamData.max_playerPerTeam,
    errorObj = {},
    skillObj = {
      1: 2,
      2: 5,
      3: 5,
      4: 3,
    },
    teamsSelected = [],
    myTeam = [],
    ROIplayers = orderBy(
      forEach(
        filter(playerList, (pl) => {
          return (
            pl.AvailableStatus != "E" &&
            pl.AvailableStatus != "I" &&
            pl.AvailableStatus != "S" &&
            pl.AvailableStatus != "D" &&
            pl.AvailableStatus != "R" &&
            pl.AvailableStatus != "NIS"
          );
        }),
        (p) => {
          p.ROI = parseFloat(p.Overallpoints / p.Value).toFixed(2);
        }
      ),
      ["ROI", "Value"],
      ["desc", "desc"]
    ),
    // topFifty = shuffle(ROIplayers.slice(0, 50)),
    topTen = shuffle(ROIplayers.slice(0, 10)),
    noOfStarPlayers = 3;
  if (teamData.playersInTeam && teamData.playersInTeam.length) {
    forEach(teamData.playersInTeam, (pId) => {
      let playerObj = find(playerList, (p) => {
        return p.Id == pId;
      });
      if (playerObj) {
        myTeam.push(playerObj);
        skillObj[playerObj.Skill] = skillObj[playerObj.Skill] - 1;
        teamsSelected.push(playerObj.TeamId);
      } else {
        /* when you have ["E", "I", "S", "D", "R", "NIS"] status player */
        let extractedPlayer = getPlayerInteam(pId, teamData);
        if (extractedPlayer && extractedPlayer.details) {
          myTeam.push(extractedPlayer.details);
          skillObj[extractedPlayer.details.Skill] =
            skillObj[extractedPlayer.details.Skill] - 1;
          teamsSelected.push(extractedPlayer.details.TeamId);
        }
      }
    });
    noOfStarPlayers = 0;
  }
  // let starPlayers = sampleSize(topTen, noOfStarPlayers);
  //Fill star playeras
  // fillStarPlayers(starPlayers, myTeam, teamsSelected, skillObj);
  addPlayers(topTen, true);
  //Adding remaining players
  addPlayers(ROIplayers);
  if (myTeam.length < 15) {
    errorObj.isAutofillError = true;
  }
  function addPlayers(Players, isStarPlayers) {
    for (let i = myTeam.length; i < 15; i++) {
      let remainingPlyrCount = 15 - i;
      if (remainingPlyrCount <= 0 || (isStarPlayers && noOfStarPlayers <= 0)) {
        break;
      }
      let avgRemBudgetPerPlayer = Budget / remainingPlyrCount;
      let PlyrsInBudget = orderBy(
        Players.filter((p) => {
          if (p.Value <= avgRemBudgetPerPlayer) {
            return true;
          }
          return false;
        }),
        ["Value"],
        ["desc"]
      );
      PlyrsInBudgetloop: for (let i = 0; i < PlyrsInBudget.length / 20; i++) {
        let start = i == 0 ? i : end + 1;
        let end = i == 0 ? 20 : (i + 1) * 20;
        let playersChunk = shuffle(PlyrsInBudget.slice(start, end));
        budget: for (let p in playersChunk) {
          let budgetPlayer = playersChunk[p];
          let canAddFromThisTeam = teamsSelected.length
            ? teamsSelected.filter((t) => {
                return t == budgetPlayer.TeamId;
              }).length < maxPerTeam
            : true;
          let canAddFromThisSkill = skillObj[budgetPlayer.Skill] > 0;
          let isAlreadyInTeam = myTeam.length
            ? findIndex(myTeam, (pl) => {
                return pl.Id == budgetPlayer.Id;
              }) >= 0
            : false;
          if (!isAlreadyInTeam && canAddFromThisSkill && canAddFromThisTeam) {
            if (isStarPlayers) {
              if (noOfStarPlayers <= 0) {
                break budget;
              }
              noOfStarPlayers = noOfStarPlayers - 1;
            }
            myTeam.push(budgetPlayer);
            teamsSelected.push(budgetPlayer.TeamId);
            Budget = Budget - budgetPlayer.Value;
            skillObj[budgetPlayer.Skill] = skillObj[budgetPlayer.Skill] - 1;
            break PlyrsInBudgetloop;
            // break budget;
          }
        }
      }
    }
  }
  myTeam = orderBy(myTeam, ["Skill", "Value"], ["desc", "desc"]);
  for (let p in myTeam) {
    let player = myTeam[p];
    let skill = player.Skill;
    let skillArr = teamData[skill];
    let benchArr = teamData[0];
    let emptyPlayer = null;
    let isOldPlayer = find(teamData.playersInTeam, (pId) => {
      return pId == player.Id;
    });
    if (!isOldPlayer) {
      if (isManageTeam) {
        emptyPlayer = find(skillArr, (pl) => {
          return !pl.id && pl.DBDetails && pl.DBDetails.id == player.Id;
        });
        if (!emptyPlayer) {
          emptyPlayer = find(benchArr, (pl) => {
            return !pl.id && pl.DBDetails && pl.DBDetails.id == player.Id;
          });
        }
      }
      if (!emptyPlayer) {
        emptyPlayer = find(skillArr, (pl) => {
          return !pl.id && pl.skill == player.Skill;
        });
      }
      if (!emptyPlayer) {
        emptyPlayer = find(benchArr, (pl) => {
          return !pl.id && pl.skill == player.Skill;
        });
      }
    }
    if (emptyPlayer && !isOldPlayer) {
      emptyPlayer.id = player.Id;
      emptyPlayer.details = myTeam[p];
      if (emptyPlayer.isCaptain) {
        teamData.captainID = emptyPlayer.Id;
      }
      teamData.playerCount++;
      teamData.playersInTeam.push(player.Id);
    }
  }
  teamData.budget = parseFloat(Budget).toFixed(1);
  setLocalStorage("teamData", teamData);
  return { teamData, errorObj };
}

export function setHighlight(teamData, objKey, playerIndex) {
  let teamDataT = JSON.parse(JSON.stringify(teamData));
  teamDataT &&
    teamDataT[0].forEach((obj, ind) => {
      teamDataT[obj.skill].push(obj);
    });
  if (teamData[objKey][playerIndex]) {
    updatePropInTeam(teamData, "isHighlighted", false);
    teamData[objKey][playerIndex].isHighlighted = true;
    const skill = teamData[objKey][playerIndex].skill;
    teamData.highlightedSkill = {
      skill: skill,
      rowIndex: objKey,
      playerIndex: playerIndex,
    };
  } else {
    updatePropInTeam(teamDataT, "isHighlighted", false);
    teamDataT[objKey][playerIndex].isHighlighted = true;
    const skill = teamDataT[objKey][playerIndex].skill;
    teamDataT.highlightedSkill = {
      skill: skill,
      rowIndex: objKey,
      playerIndex: playerIndex,
    };
  }

  return teamData[objKey][playerIndex] ? teamData : teamDataT;
}

export function isWebView() {
  let queryParamsObj = getQueryParamsObject();
  if (queryParamsObj.webview === "true") {
    return true;
  } else {
    return false;
  }
}

export function isLocation(continent, geolocationdata) {
  return continent === geolocationdata.continent;
}

export function getLocalStorage(key) {
  //append namespace of this season
  const localData = localStorage.getItem(config.namespaceKey + key);
  if (localData == null) {
    return false;
  }
  try {
    return JSON.parse(localData);
  } catch (e) {
    return false;
  }
}
export function setLocalStorage(key, value) {
  localStorage.setItem(config.namespaceKey + key, JSON.stringify(value));
}
export function removeLocalStorage(key, considerNameSpace) {
  if (considerNameSpace) {
    localStorage.removeItem(config.namespaceKey + key);
  } else {
    localStorage.removeItem(key);
  }
}

export function isUndefined(value) {
  return typeof value === "undefined";
}

export function makeCaptain(teamData, objKey, playerIndex, player) {
  if (isUndefined(objKey) || isUndefined(playerIndex) || isEmpty(objKey)) {
    const playerPosition = getPlayerPosition(player.id, teamData);
    objKey = playerPosition.rowIndex;
    playerIndex = playerPosition.playerIndex;
    player = playerPosition.player;
  }
  updatePropInTeam(teamData, "isCaptain", false);
  teamData[objKey][playerIndex].isCaptain = true;
  teamData.captainID = player.id;
  setLocalStorage("teamData", teamData);
  return teamData;
}

export function validateInput(value) {
  /* eslint-disable */
  if (value[0] === " ") {
    return value.replace(/["\/\\<>|;]/gi, "").trim();
  }
  return value.replace(/["\/\\<>|;]/gi, "");
  /* eslint-enable */
}

export function CompConvertHexToString(shareLoad) {
  let hex = shareLoad.toString(); //force conversion
  // let str = '';
  // for (let i = 0; i < hex.length; i += 2)
  //   str += String.fromCharCode(parseInt(hex.substr(i, 2), 16));
  var j;
  var hexes = hex.match(/.{1,4}/g) || [];
  var str = "";
  for (j = 0; j < hexes.length; j++) {
    str += String.fromCharCode(parseInt(hexes[j], 16));
  }
  // let leagueArr = ["v1", "v2", "v3", "v4"];
  // let new_tempArr = str.split("##");
  // let temp = "";
  // for (let j = 0; j < new_tempArr.length; j++) {
  //   temp += leagueArr[j] + "#=#" + new_tempArr[j];
  //   if (j < new_tempArr.length - 1) temp += "&=&";
  // }
  // let cookieObj = {};
  // temp = temp.split("&=&");
  // for (let i = 0, l = temp.length; i < l; i++) {
  //   let x = temp[i];
  //   let temp1 = x.split("#=#");
  //   let key = temp1[0];
  //   cookieObj[key] = temp1[1].replace(/\+/g, " ");
  // }
  return str;
}

export function getOrderedPlayerIDs(teamData) {
  return orderToScan.reduce((accumulator, key) => {
    const plainIDs = teamData[key].map((player) => player.id);
    return accumulator.concat(plainIDs);
  }, []);
}

//realted to cookies and login
export function getCookie(c_name) {
  let i,
    x,
    y,
    cookiesArray = document.cookie.split(";");
  for (i = 0; i < cookiesArray.length; i++) {
    x = cookiesArray[i].substr(0, cookiesArray[i].indexOf("="));
    y = cookiesArray[i].substr(cookiesArray[i].indexOf("=") + 1);
    x = x.replace(/^\s+|\s+$/g, "");
    if (x === c_name) {
      return y;
    }
  }
}

export function deleteCookie(name) {
  document.cookie = `${name}=; Path=/;domain=.uefa.com; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
}

export function parseCookie(logindata) {
  // try {
  //   if (logindata && logindata.data && logindata.data[config.COOKIE_GM]) {
  //     return logindata.data[config.COOKIE_GM];
  //   } else {
  //     return false;
  //   }
  // } catch (e) {}
  try {
    if (logindata) {
      return logindata;
    } else {
      return false;
    }
  } catch (e) {}
}

export function isLoggedIn(logindata) {
  // let userProfile = parseCookie(getCookie(config.COOKIE_GM));
  if (logindata && logindata.data && logindata.data[config.COOKIE_GM]) {
    return true;
  } else {
    return false;
  }
}

export function hasTeam() {
  let userProfile = getLoginCookie();
  if (userProfile?.HasTeam === "1") {
    return true;
  } else {
    return false;
  }
}

// export function getUserProfile(logindata) {
export function getUserProfile() {
  let userProfile = getLoginCookie();
  // let userProfile =
  //   (logindata && logindata.data && logindata.data[config.COOKIE_GM]) || null;
  if (userProfile) {
    return userProfile;
  } else {
    return false;
  }
}

export const getPlayingEleven = (teamData, withCaptain) => {
  let playinEleven = [];
  each(orderToScan, (i) => {
    i !== 0 &&
      teamData &&
      teamData[i].forEach((obj) => {
        withCaptain
          ? playinEleven.push(obj)
          : !obj.isCaptain && playinEleven.push(obj);
      });
  });
  return playinEleven;
};
//end

// export function setPrevLocation(path) {
//   window[config.namespaceKey]["prevScreen"] = path
// }

export function setLocation(path) {
  // if (window[config.namespaceKey]["currentScreen"]) {
  //   setPrevLocation(window[config.namespaceKey]["currentScreen"])
  // }
  window[config.namespaceKey]["currentScreen"] = path;
  //check for ads code
  if (config.addAdsclass.indexOf(path) > -1) {
    $("#MainPitchContainer").addClass("si-bg--img");
  } else {
    $("#MainPitchContainer").removeClass("si-bg--img");
  }
}

export function setDate(date, format) {
  // return (new Date(date)).format(format);
  //dont use this
  return new Date(date);
}

export function showLoader() {
  // $("#loaderWrap").show();
  setTimeout(() => {
    return console.log("loading");
  }, 500000);
}

export function hideLoader() {
  $("#loaderWrap").hide();
}

export function getOutTeamArray(teamData, oldTeamData) {
  let diff = [];
  const areBothDataSameInSkeleton = every(orderToScan, (i) => {
    return (
      oldTeamData &&
      oldTeamData[i] &&
      teamData[i] &&
      oldTeamData[i].length === teamData[i].length
    );
  });
  if (areBothDataSameInSkeleton) {
    forEach(orderToScan, (skillIndex) => {
      const difference = filter(oldTeamData[skillIndex], (player, index) => {
        return player.id !== teamData[skillIndex][index].id;
      });
      let currDiff = filter(difference, (player) => player.id !== null);
      if (currDiff.length) diff = diff.concat(currDiff);
    });
  }
  return diff;
}

export function getStatus(player, islateOnboard) {
  let pStatus = "";
  if (player.details) {
    pStatus = player.details.pStatus;
  } else {
    pStatus = player.pStatus;
  }

  if (islateOnboard) {
    if (
      player.details.teamPlayed ||
      (player.DBDetails && !player.DBDetails.isactive)
    ) {
      pStatus = config.warningStatus;
    }
  }
  return config.statusIcons[pStatus]
    ? {
        class: config.statusIcons[pStatus].class,
        text: config.statusIcons[pStatus].text,
        textTrack: config.statusIcons[pStatus].textTrack,
      }
    : { class: "", text: "" };
}

export function getSubsPlayer(teamData, islateOnboard) {
  let showWarning = false;
  find(orderToScan, (position) => {
    return find(teamData[position], (player, index) => {
      let isLateonboardedPly =
        getStatus(player, islateOnboard).text == "already_played"
          ? true
          : false;

      if (player.substituted === true && !isLateonboardedPly) {
        if (
          player.DBDetails &&
          !(
            player.DBDetails.overallpoints === undefined ||
            player.DBDetails.overallpoints === null ||
            player.DBDetails.overallpoints === "" ||
            player.DBDetails.overallpoints == 0
          )
        ) {
          showWarning = true;
        }
      }
    });
  });
  return showWarning;
}

export const redirectToPredictor = () => {
  window.open(
    window.location.origin + config.PREDCITOR_DOMAIN + config.language
  );
};

export function makeJerseyAnimate(objkey) {
  let buffer = 0;
  let idMobileWrap =
    $("#mobileHeader")[0].offsetHeight +
    $(".si-pitch__header")[0].offsetHeight +
    95 +
    116;
  let pitchWrapHeight = $(".si-pitch")[0].offsetHeight;
  // let marginGiven = 174;
  // let headWrapper = $(".si-head__wrapper")[0].offsetHeight;

  buffer = 60;

  let eachColumDiff = pitchWrapHeight / 5;

  if (config.isMobile) {
    let scrollPosition = 100;
    switch (parseInt(objkey)) {
      case 0:
        scrollPosition = idMobileWrap + eachColumDiff * 4;
        break;
      case 1:
        scrollPosition = idMobileWrap + eachColumDiff * 3;
        break;
      case 2:
        scrollPosition = idMobileWrap + eachColumDiff * 2;
        break;
      case 3:
        scrollPosition = idMobileWrap + eachColumDiff;
        break;
      case 4:
        scrollPosition = idMobileWrap;
        break;
      default:
        scrollPosition = idMobileWrap;
      // code block
    }

    $("html,body").animate(
      {
        scrollTop: scrollPosition - buffer,
      },
      500
    );
  }
}

export function detechChromeBrowser() {
  var ua = navigator.userAgent.toLowerCase();
  if (ua.indexOf("safari") != -1) {
    if (ua.indexOf("chrome") > -1) {
      return true;
    } else {
      return false;
    }
  }
  if (ua.indexOf("firefox") != -1) {
    if (ua.indexOf("mozilla") != -1) {
      return true;
    }
  }
}

export function getIsPlyListEdit() {
  if (
    window[config.namespaceKey] &&
    window[config.namespaceKey].currentScreen
  ) {
    if (
      window[config.namespaceKey].currentScreen == "/manage-team" ||
      window[config.namespaceKey].currentScreen == "/create-team"
    ) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
}

export function clearLocalStorage() {
  let gdprValue = getLocalStorage("setGDPR");
  localStorage.clear();
  setLocalStorage("setGDPR", gdprValue);
}

export function isDisabled(value) {
  if (value) {
    return (
      value.length > 0 &&
      value.trim().length < config.MAX_TEAM_NAME_LENGTH &&
      value.trim().length >= config.MIN_TEAM_NAME_LENGTH
    );
  } else {
    return false;
  }
}

export function getLateOnBoardingPlayers(teamData) {
  let lateOnbardingPlayer = [];
  find(orderToScan, (position) => {
    return find(teamData[position], (player, index) => {
      if (player.details.teamPlayed) {
        lateOnbardingPlayer.push(player);
      }
    });
  });
  return lateOnbardingPlayer;
  // let lateObPlysList = playerList.map((player) => {
  //   if (player.teamPlayed) {
  //     return player;
  //   }
  // })

  // return lateObPlysList;
}

export function getPlayerFromTeam(playerId, teamData) {
  let playerObj = {};

  for (let o = 0; o < orderToScan.length; o++) {
    for (let p = 0; p < teamData[orderToScan[o]].length; p++) {
      if (teamData[orderToScan[o]][p].id === playerId) {
        playerObj = teamData[orderToScan[o]][p];
        break;
      }
    }
  }
  return playerObj;
}

export function getMatchdayNode(gamedays) {
  let status = 0;
  forIn(gamedays, function (value, key) {
    if (value.mds == 0) {
      //write logic for get current status
      status = key;
    }
  });

  forIn(gamedays, function (value, key) {
    if (value.mds == 2) {
      //write logic for get current status
      status = key;
    }
  });

  // // /check for live matches
  forIn(gamedays, function (value, key) {
    if (value.mds == 1) {
      //write logic for get current status
      status = key;
    }
  });
  return status;
}

export function getCurrMatchForPlayerList(gamedays) {
  let status = 0;
  let lastMd = 0;
  forIn(gamedays, function (value, key) {
    if (value.mds == 0) {
      //write logic for get current status
      status = key;
    } else {
      lastMd = key;
    }
  });
  if (status == 0) {
    status = lastMd;
  }

  return status;
}

export function checkForAnyGamedayLive(fixtures) {
  let liveGameday = (fixtures || []).find((obj) => {
    return (
      obj.GDIsCurrent === 1 &&
      obj.GDIsLocked === 1 &&
      obj.MatchIsCurrent === 1 &&
      obj.MatchIsLocked === 1
    );
  });
  return liveGameday ? true : false;
}

export function getFixtureMode(selectedFixture) {
  let jStatus = getFixtureStatus(selectedFixture);
  if (jStatus === config.fixtureStatus.isUpComing) {
    return config.modes.transfer;
  } else if (jStatus === config.fixtureStatus.isOpen) {
    return config.modes.transfer;
  } else if (jStatus === config.fixtureStatus.isNewUser) {
    return config.modes.transfer;
  } else if (jStatus === config.fixtureStatus.isSubstitution) {
    return config.modes.substitution;
  } else if (jStatus === config.fixtureStatus.isLock) {
    return config.modes.live;
  } else if (jStatus === config.fixtureStatus.isFinished) {
    return config.modes.viewpoint;
  }
}

export const getGamedayStatus = (fixture) => {
  let { GDIsLocked, GDIsCurrent, MatchIsLocked, MatchIsCurrent } = fixture;
  let mode = config.modes.transfer;
  if (GDIsCurrent === 1 && GDIsLocked === 1) {
    if (MatchIsCurrent === 1 && MatchIsLocked === 1) {
      mode = config.modes.live;
    }
    if (MatchIsCurrent === 2 && MatchIsLocked === 1) {
      mode = config.modes.substitution;
    }
  } else if (
    GDIsCurrent === 2 &&
    GDIsLocked === 1 &&
    MatchIsCurrent === 2 &&
    MatchIsLocked === 1
  ) {
    mode = config.modes.viewpoint;
  }
  return mode;
};

export function setGameModeOnFixtures(fixturesMode) {
  switch (fixturesMode) {
    case 0: {
      // return config.modes.transfer;
      return config.modes.transfer;
    }
    case 1: {
      return config.modes.live;
    }
    case 2: {
      return config.modes.substitution;
    }
    case 3: {
      return config.modes.viewpoint;
    }
    default: {
      return config.modes.transfer;
    }
  }
}

//get current scenarios of games
export function getFixtureStatus(fixture) {
  let { MatchIsLocked, MatchIsCurrent, GDIsLocked, GDIsCurrent } = fixture;
  MatchIsLocked = +MatchIsLocked;
  MatchIsCurrent = +MatchIsCurrent;
  GDIsLocked = +GDIsLocked;
  GDIsCurrent = +GDIsCurrent;
  //MdIsLckd dispute
  switch (true) {
    case MatchIsLocked === 0 &&
      MatchIsCurrent === 0 &&
      GDIsLocked === 0 &&
      GDIsCurrent === 0: {
      return config.fixtureStatus.isUpComing;
    }
    case MatchIsLocked === 1 &&
      MatchIsCurrent === 1 &&
      GDIsLocked === 1 &&
      GDIsCurrent === 1: {
      return config.fixtureStatus.isLock;
    }
    case MatchIsLocked === 1 &&
      MatchIsCurrent === 1 &&
      GDIsLocked === 0 &&
      GDIsCurrent === 1: {
      return config.fixtureStatus.isSubstitution;
    }
    case MatchIsLocked === 1 &&
      MatchIsCurrent === 2 &&
      GDIsLocked === 1 &&
      GDIsCurrent === 2: {
      return config.fixtureStatus.isFinished;
    }
    case MatchIsLocked === 0 &&
      MatchIsCurrent === 1 &&
      GDIsLocked === 0 &&
      GDIsCurrent === 1: {
      return config.fixtureStatus.isOpen;
    }
    default: {
      return config.fixtureStatus.isUpComing;
    }
  }
}

export function addFixturesStatus(rawFixtures) {
  const fixtures = clone(rawFixtures);
  forEach(fixtures, (fixture) => {
    fixture.status = getFixtureStatus(fixture);
  });
  return fixtures;
}

//get current mode of the game

///substitution window
export function resetSubstitution(teamData) {
  orderToScan.forEach((position) => {
    teamData[position].forEach((player) => {
      delete player.couldBeUsedToReplace;
      delete player.toBeSubstituted;
      delete player.substituted;
    });
  });
}

export function cancelSubstitution(teamDataRaw) {
  const teamData = clone(teamDataRaw);
  orderToScan.forEach((position) => {
    teamData[position].forEach((player) => {
      delete player.couldBeUsedToReplace;
      delete player.toBeSubstituted;
    });
  });
  delete teamData.substitutionInitiated;
  return teamData;
}

export function canMovePlayer(
  arrSelectedPlayer,
  dragObject,
  dropObject,
  dragRowIndex,
  dragColumnIndex,
  jSkillFormationLengthDrop
) {
  let dragId = +dragObject.id,
    dragSkillId = +dragObject.skill,
    isDragBench = dragObject.isBench,
    dropId = +dropObject.id,
    dropSkillId = +dropObject.skill,
    isDropBench = dropObject.isBench;
  let fResp = false;
  //goal keeper only
  if (dropId !== config.emptyValue && dragId !== dropId) {
    if (
      +dragSkillId === +config.EnumPosition.Goalkeepers &&
      +dragSkillId === +dropSkillId
    ) {
      fResp = true;
      let objPlayer = dropObject.details;
      if (objPlayer && objPlayer.Id !== config.emptyValue) {
        if (isDropBench && +objPlayer.isPlayed) {
          fResp = false;
        }
        if (+objPlayer.isredcard) {
          fResp = false;
        }
      }
    } else if (
      dragSkillId !== config.EnumPosition.Goalkeepers &&
      dropSkillId !== config.EnumPosition.Goalkeepers
    ) {
      if (isDragBench) {
        //drop = bench
        let flag = false;
        let jMinLength = config.EnumMinPositionNos[dropSkillId];
        if (jMinLength < jSkillFormationLengthDrop) {
          flag = true;
        }
        if (isDropBench || +dragSkillId === +dropSkillId || flag) {
          fResp = true;
          //if it is GDExists.
          let objPlayer = dropObject.details;
          if (objPlayer && objPlayer.Id !== config.emptyValue) {
            if (isDropBench && +objPlayer.isPlayed) {
              fResp = false;
            }
            if (+objPlayer.isredcard) {
              fResp = false;
            }
          }
        }
      } else if (!isDragBench) {
        //drag from player
        let flag = false;
        let jMaxLength = config.EnumMaxPositionNosBench[dragSkillId];
        let jMaxLengthBench = 0;
        let cellData = arrSelectedPlayer[dragRowIndex][dragColumnIndex];
        let rowDataBench = arrSelectedPlayer["0"];
        if (cellData) {
          //check count in bench
          for (let jNdex = 0; jNdex < (rowDataBench || []).length; jNdex++) {
            let row = rowDataBench[jNdex];
            if (+row.skill === +cellData.skill) {
              jMaxLengthBench = jMaxLengthBench + 1;
            }
          }
        }
        if (
          (jMaxLength !== jMaxLengthBench &&
            (dragSkillId !== dropSkillId || +dragSkillId === +dropSkillId)) ||
          (+jMaxLength === +jMaxLengthBench && +dragSkillId === +dropSkillId)
        ) {
          flag = true;
        }
        if (isDropBench && flag) {
          fResp = true;
        }
        //if it is GDExists.
        let objPlayer = dropObject.details;
        if (objPlayer && objPlayer.Id !== config.emptyValue) {
          if (+objPlayer.isPlayed) {
            fResp = false;
          }
          if (+objPlayer.isredcard) {
            fResp = false;
          }
        }
      }
    }
  }
  return fResp;
}

export function isPlayerInBench(passedTeamData, playerID) {
  return some(passedTeamData["0"], (player) => {
    return player.id === playerID;
  });
}

function addSubstitutedKey(teamData, manageTeamRawData) {
  orderToScan.forEach((skillIndex) => {
    if (skillIndex !== "0") {
      teamData[skillIndex].forEach((player) => {
        const status = isPlayerInBench(manageTeamRawData, player.id);
        if (status === true) {
          player.substituted = true;
        }
      });
    }
  });
  teamData["0"].forEach((player, index) => {
    const foundIndex = findIndex(manageTeamRawData["0"], (oldPlayer) => {
      return oldPlayer.id === player.id;
    });
    if (foundIndex === -1) {
      player.substituted = true;
    } else if (foundIndex !== index) {
      player.substituted = true;
    }
  });
  return teamData;
}

export function substituteThisPlayer(teamDataRaw, playerData) {
  let teamData = clone(teamDataRaw);
  teamData = cancelSubstitution(teamData);
  const playerPosition = getPlayerPosition(playerData.id, teamData);
  const { rowIndex, playerIndex } = playerPosition;
  /*To set `toBeGoingOut` or `toBeGoingIn` based on bench position */
  orderToScan.some((key) => {
    return teamData[key].some((player) => {
      if (player.id === playerData.id) {
        player["toBeSubstituted"] = true;
        return true;
      }
      return false;
    });
  });
  forEach(orderToScan, (skillKey) => {
    forEach(teamData[skillKey], (playerObj) => {
      const lenOfSkill = teamData[playerObj.skill].length;
      const canMove = canMovePlayer(
        teamData,
        playerData,
        playerObj,
        rowIndex,
        playerIndex,
        lenOfSkill
      );
      if (canMove) {
        playerObj.couldBeUsedToReplace = true;
      }
    });
  });
  teamData.substitutionInitiated = true;
  teamData.IsBenchSubstitution = playerData.isBench;
  teamData.benchSubstitution = playerData;
  delete teamData.substitutionCompleted;
  return teamData;
}

export function replaceWithThisPlayer(
  teamDataRaw,
  manageTeamRawData,
  playerData
) {
  const teamData = clone(teamDataRaw);
  const toBeSubstitutedPlayer = getPlayerByKeyFromTeamData(
    teamData,
    "toBeSubstituted",
    true
  );
  const toBeReplacedPlayer = getPlayerByKeyFromTeamData(
    teamData,
    "id",
    playerData.id
  );
  const toBeSubSkill = toBeSubstitutedPlayer.skill;
  const toBeReplacedSkill = playerData.skill;
  const areBothFromBench =
    toBeReplacedPlayer.data.isBench === true &&
    toBeSubstitutedPlayer.data.isBench === true;
  if (toBeSubSkill === toBeReplacedSkill || areBothFromBench) {
    const { rowIndex, playerIndex } = toBeSubstitutedPlayer;
    const skillIdentifierOfToBeReplaced = toBeReplacedPlayer.rowIndex;
    const positionIndexOfToBeReplaced = toBeReplacedPlayer.playerIndex;
    if (!areBothFromBench) {
      /*If both are fro bench, ignore captain case*/ if (
        toBeSubstitutedPlayer.data.isBench
      ) {
        /*Player is in bench and now will be in team*/
        toBeSubstitutedPlayer.data.isCaptain =
          toBeReplacedPlayer.data.isCaptain;
        toBeReplacedPlayer.data.isCaptain = false;
      }
      if (toBeReplacedPlayer.data.isBench) {
        /*Player is in bench and now will be in team*/
        toBeReplacedPlayer.data.isCaptain =
          toBeSubstitutedPlayer.data.isCaptain;
        toBeSubstitutedPlayer.data.isCaptain = false;
      }
    }
    teamData[skillIdentifierOfToBeReplaced][positionIndexOfToBeReplaced] =
      clone({
        ...toBeSubstitutedPlayer.data,
        isBench: +skillIdentifierOfToBeReplaced === 0,
      });
    teamData[rowIndex][playerIndex] = clone({
      ...toBeReplacedPlayer.data,
      isBench: +rowIndex === 0,
    });
  } else {
    let whoIsFromBench = toBeReplacedPlayer.data.isBench
      ? "toBeReplacedPlayer"
      : "toBeSubstitutedPlayer";
    const skillIdentifierOfToBeReplaced = toBeReplacedPlayer.rowIndex;
    const positionIndexOfToBeReplaced = toBeReplacedPlayer.playerIndex;
    const skillOfToBeReplaced = toBeReplacedPlayer.skill;
    const skillIdentifierOfToBeSubstituted = toBeSubstitutedPlayer.rowIndex;
    const positionIndexOfToBeSubstituted = toBeSubstitutedPlayer.playerIndex;
    const skillOfToBeSubstituted = toBeSubstitutedPlayer.skill;
    if (toBeSubstitutedPlayer.data.isBench) {
      /*Player is in bench and now will be in team*/
      toBeSubstitutedPlayer.data.isCaptain = toBeReplacedPlayer.data.isCaptain;
      toBeReplacedPlayer.data.isCaptain = false;
    }
    if (toBeReplacedPlayer.data.isBench) {
      /*Player is in bench and now will be in team*/
      toBeReplacedPlayer.data.isCaptain = toBeSubstitutedPlayer.data.isCaptain;
      toBeSubstitutedPlayer.data.isCaptain = false;
    }
    if (whoIsFromBench === "toBeReplacedPlayer") {
      teamData[skillIdentifierOfToBeReplaced][positionIndexOfToBeReplaced] =
        clone({
          ...toBeSubstitutedPlayer.data,
          isBench: +skillIdentifierOfToBeReplaced === 0,
        });
      teamData[skillOfToBeReplaced].push(
        clone({
          ...toBeReplacedPlayer.data,
          isBench: +skillOfToBeReplaced === 0,
        })
      );
      teamData[skillIdentifierOfToBeSubstituted].splice(
        positionIndexOfToBeSubstituted,
        1
      );
    } else {
      teamData[skillIdentifierOfToBeSubstituted][
        positionIndexOfToBeSubstituted
      ] = clone({
        ...toBeReplacedPlayer.data,
        isBench: +skillIdentifierOfToBeSubstituted === 0,
      });
      teamData[skillOfToBeSubstituted].push(
        clone({
          ...toBeSubstitutedPlayer.data,
          isBench: +skillOfToBeSubstituted === 0,
        })
      );
      teamData[skillIdentifierOfToBeReplaced].splice(
        positionIndexOfToBeReplaced,
        1
      );
    }
  }
  resetSubstitution(teamData);
  addSubstitutedKey(teamData, manageTeamRawData);
  const captainObj = getPlayerByKeyFromTeamData(teamData, "IsCaptain", true);
  teamData.captainID =
    captainObj && captainObj.data ? captainObj.data.id : teamData.captainID;
  delete teamData.substitutionInitiated;
  teamData.substitutionCompleted = true;
  return teamData;
}

export function getSubstitutionStatus(oldTeamData, newTeamData) {
  let response = { count: 0, substituted: false };
  const diff = filter(oldTeamData["0"], (player) => {
    const isPlayerNotInBench = (playerID, otherBench) => {
      return find(otherBench, (benchPlayer) => {
        return benchPlayer.id === playerID;
      });
    };
    return !isPlayerNotInBench(player.id, newTeamData["0"]);
  });
  if (diff.length === 0) {
    response.substituted = some(oldTeamData["0"], (player, index) => {
      return player.id !== newTeamData["0"][index].id;
    });
  } else {
    response.count = diff.length;
    response.substituted = true;
  }
  return response;
}

export function getAutoSubstitutionsApiData(teamDataRaw, rawTeamData) {
  const teamData = clone(teamDataRaw);
  const isPlayerSubstituted = (oldTeamData, index, playerId) => {
    return some(oldTeamData[index], (player) => {
      return player.id === playerId;
    });
  };
  orderToScan.forEach((skillIndex) => {
    if (skillIndex !== "0") {
      teamData[skillIndex].forEach((player, index) => {
        const { id } = player;
        const playerNotSubstituted = isPlayerSubstituted(
          rawTeamData,
          skillIndex,
          id
        );
        if (!playerNotSubstituted) {
          player.substituted = true;
        }
      });
    }
  });
  teamData["0"].forEach((player, index) => {
    const { id } = player;
    // if (rawTeamData["0"][index].id !== id) {
    //   player.substituted = true;
    // }
    if (rawTeamData["0"].length) {
      let filterplayer = rawTeamData["0"].filter(function (item) {
        if (item.id == id) return item;
      });
      if (!filterplayer.length) {
        player.substituted = true;
      }
    }
  });
  return teamData;
}

export function getTeamDeadlineObj(
  trans,
  OffSet = "+0",
  MDeadline,
  month = "ddMMM",
  dateWithTime = false,
  ddMMMWithoutTime = false
) {
  let deadlineObj = {};
  let isSubsDeadline = false;
  let isTeamLockDeadline = false;
  let matchTime = "";
  let displayDate = "";
  let Deadline = MDeadline;

  if (Deadline) {
    let dateParams = {
      matchTime: Deadline,
      offSet: OffSet,
      dateWithTime: dateWithTime,
      ddMMMWithoutTime: ddMMMWithoutTime,
      month: month,
    };

    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const monthNamesShort = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const dayNames = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    const dayNamesShort = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

    //Deadline = cestToLocalTime(dateParams);
    //Deadline = moment(new Date(Deadline));
    Deadline = new Date(Deadline);

    let daysNameShort = dayNamesShort[Deadline.getDay()];
    let daysNameLong = dayNames[Deadline.getDay()];
    let dayInt = ("0" + Deadline.getDate()).slice(-2);
    let monthsNameShort = getTrans(trans, monthNamesShort[Deadline.getMonth()]);
    let monthsNameLong = monthNames[Deadline.getMonth()];
    let monthInt = ("0" + Deadline.getMonth()).slice(-2);
    let year = Deadline.getFullYear();
    let date = dayInt + " " + monthsNameShort;

    let getHours = ("0" + Deadline.getHours()).slice(-2);
    let getMinutes = ("0" + Deadline.getMinutes()).slice(-2);
    matchTime = getHours + ":" + getMinutes;

    let dateWithYear = dayInt + " " + monthsNameShort + " " + year;

    displayDate = date;
    deadlineObj.dayShort = getTrans(trans, daysNameShort);
    deadlineObj.dayLong = getTrans(trans, daysNameLong);
    deadlineObj.monthLong = getTrans(trans, monthsNameLong);
    deadlineObj.displayDate = displayDate;
    deadlineObj.dayInt = dayInt;
    deadlineObj.displayDatewithDay = deadlineObj.dayShort + " " + displayDate;
    deadlineObj.matchTime = matchTime;
    deadlineObj.dateWithYear = dateWithYear;
    deadlineObj.dateWithYearAndTime = dateWithYear + " " + matchTime;
    deadlineObj.dateAndTime = date + ", " + matchTime;
    deadlineObj.dateAndTimewithday =
      deadlineObj.dayShort + " " + date + ", " + matchTime;
    if (isSubsDeadline) {
      deadlineObj.deadlineText =
        trans.substitutionsUntil + " " + displayDate + ", " + matchTime;
    } else if (isTeamLockDeadline) {
      deadlineObj.isLockIcon = true;
      deadlineObj.deadlineText =
        trans.teamLock + ": " + displayDate + ", " + matchTime;
    } else {
      deadlineObj.isLockIcon = true;
      deadlineObj.deadlineText =
        trans.teamLock + ": " + displayDate + ", " + matchTime;
    }
  }
  return deadlineObj;
}

export function cestToLocalTime(dateObj) {
  var date = new Date(dateObj.matchTime);

  //CEST is 2 hrs (daylight saving--offset value) ahead of GMT hence substracted 2
  date = date.setHours(date.getHours() - dateObj.offSet); //Converted to GMT time
  date = new Date(date);
  var localOffset = new Date().getTimezoneOffset() * 60000;
  var localTime = date.getTime();
  date = localTime - localOffset;
  date = new Date(date);

  // return  moment(date).format('ddd DD MMM');

  return date;
}

export function subsWarningCheck(teamData) {
  let showWarning = false;
  orderToScan.forEach((skill) => {
    teamData[skill].forEach((player, index) => {
      if (player.substituted === true) {
        if (
          player.DBDetails &&
          player.DBDetails.IsPlayed &&
          !(
            player.DBDetails.Overallpoints === undefined ||
            player.DBDetails.Overallpoints === null ||
            player.DBDetails.Overallpoints === "" ||
            player.DBDetails.Overallpoints == 0
          )
        ) {
          showWarning = true;
        }
      }
    });
  });
  return showWarning;
}

export const doseCaptainHasPoints = (teamData) => {
  let showWarning = false;
  let captainId = teamData.captainID;
  orderToScan.forEach((skill) => {
    teamData[skill].forEach((player, index) => {
      if (player.id === captainId) {
        if (
          player.DBDetails &&
          !(
            player.DBDetails.Overallpoints === undefined ||
            player.DBDetails.Overallpoints === null ||
            player.DBDetails.Overallpoints === "" ||
            player.DBDetails.Overallpoints == 0
          )
        ) {
          showWarning = true;
        }
      }
    });
  });
  return showWarning;
};

export const getPlayerFromLive = (player, liveScoring) => {
  let playerData = player;
  liveScoring &&
    liveScoring.length &&
    liveScoring.forEach((objMtch) => {
      objMtch.PlayerPoints.forEach((objPlyr) => {
        if (
          objPlyr.PlayerId === playerData.id ||
          objPlyr.PlayerId === playerData.Id
        ) {
          playerData.teamData = objPlyr;
        }
      });
    });
  return playerData;
};

export const getPlayerStatus = (player, currMatchDay, liveData) => {
  let isPlayerPlaying = false;
  let playerTeamPlayingStatus = null;
  let playerTeamId = player.details ? player.details.TeamId : player.TeamId;
  liveData?.length &&
    liveData.forEach((obj) => {
      obj.TeamScoreLine.forEach((objTeam) => {
        if (
          objTeam.TeamId == playerTeamId &&
          obj.PlayerPoints[0].GamedayId === currMatchDay.GamedayId
        ) {
          playerTeamPlayingStatus = config.enumTeamPlayingStatus.isPlaying;
        }
      });
      if (playerTeamPlayingStatus === config.enumTeamPlayingStatus.isPlaying) {
        obj.PlayerPoints.find((objPlyr) => {
          return (player.id ? player.id : player.Id) === objPlyr.PlayerId;
        })?.PlayerId && (isPlayerPlaying = true);
      }
    });
  if (playerTeamPlayingStatus !== config.enumTeamPlayingStatus.isPlaying) {
    currMatchDay &&
      currMatchDay.match &&
      currMatchDay.match.forEach((obj) => {
        if (
          +obj.MatchStatus === config.enumMatchStatus.isUpComing &&
          (playerTeamId === obj.AwayTeamId || playerTeamId === obj.HomeTeamId)
        ) {
          playerTeamPlayingStatus = config.enumTeamPlayingStatus.willPlay;
        }
        if (
          +obj.MatchStatus === config.enumMatchStatus.isFinished &&
          (playerTeamId === obj.AwayTeamId || playerTeamId === obj.HomeTeamId)
        ) {
          playerTeamPlayingStatus = config.enumTeamPlayingStatus.hasPlayed;
        }
      });
  }
  return { isPlayerPlaying, playerTeamPlayingStatus };
};

export const getCompositionId = (teamData, formation) => {
  let def = teamData[2].length;
  let mid = teamData[3].length;
  let fwd = teamData[4].length;
  let compId = [];
  for (var i = 0; i < formation.length; i++) {
    if (
      formation[i].def == def &&
      formation[i].mid == mid &&
      formation[i].fwd == fwd
    ) {
      compId = formation[i];
    }
  }

  return compId;
};

export const getDefaultPlySort = (mdid, sortBy) => {
  if (mdid > 1) {
    return {
      // sortBy: 'totPts',
      sortByObj: {
        id: 3,
        label: "Price",
        sortId: "Value",
        labelTrans: "value",
        selected: true,
      },
      sortBy: sortBy ? sortBy : "Value",
      searchString: "",
      teamIds: [],
      teamNamesObj: [],
      priceFilterSelected: "",
      priceFilterObj: [],
      curPosFilter: 1,
      skillId: [],
      filterCount: 0,
      playerStatus: [
        {
          id: "I",
          trackLable: "Injured players",
          label: "injured",
          labelTrck: "Injured",
          siIcon: "euro-injured si-center",
          active: false,
        },
        {
          id: "S",
          trackLable: "Suspended players",
          label: "suspended",
          labelTrck: "Suspended",
          siIcon: "euro-suspended si-center",
          active: false,
        },
      ],
      playerRecomendation: ["playerRecomendationdDefault"],
    };
  } else {
    return {
      sortByObj: {
        id: 3,
        label: "Price",
        sortId: "Value",
        labelTrans: "value",
        selected: true,
      },
      sortBy: sortBy ? sortBy : "Value",
      searchString: "",
      teamIds: [],
      teamNamesObj: [],
      priceFilterSelected: "",
      priceFilterObj: [],
      curPosFilter: 1,
      skillId: [],
      filterCount: 0,
      playerStatus: [
        {
          id: "I",
          trackLable: "Injured players",
          label: "injured",
          labelTrck: "Injured",
          siIcon: "euro-injured si-center",
          active: false,
        },
        {
          id: "S",
          trackLable: "Suspended players",
          label: "suspended",
          labelTrck: "Suspended",
          siIcon: "euro-suspended si-center",
          active: false,
        },
      ],
      playerRecomendation: ["playerRecomendationdDefault"],
    };
  }
};

export const getIsLateOnboardUser = (gamedays, currMd) => {
  if (gamedays && currMd) {
    if (
      currMd.match &&
      currMd.match.length &&
      gamedays.ftGdid > currMd.match[0].gdId
    ) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
};

export const isPlayerLateOnbaord = (
  playerDtl,
  isactive,
  selectedFixture,
  ftGdid
) => {
  // if (gamemode == config.gameMode.createTeam) {
  //   return (playerDtl && playerDtl.teamPlayed == 1)
  // }
  if (
    ftGdid &&
    selectedFixture &&
    selectedFixture.match &&
    selectedFixture.match.length &&
    ftGdid > selectedFixture.match[0].gdId
  ) {
    return (playerDtl && playerDtl.teamPlayed == 1) || !isactive;
  }
  return false;
};

// booster logic

export function isBoosterTaken(type, teamData, currentActiveFixture) {
  let isTaken = false;

  const { mdId } = currentActiveFixture;
  if (type === "isWildCardTaken") {
    const wildCardStatus = getWildCardStatus(teamData, mdId);
    isTaken =
      wildCardStatus === config.wildCardStatus["usedInCurrent"] ||
      wildCardStatus === config.wildCardStatus["usedInCurrentTemp"];
  } else if (type === "isBoosterOneTaken") {
    const limitlessStatus = getBoosterStatus(teamData, mdId);
    isTaken =
      limitlessStatus === config.limitlessBoosterStatus["usedInCurrent"] ||
      limitlessStatus === config.limitlessBoosterStatus["usedInCurrentTemp"];
  }
  return isTaken;
}

export function getWildCardStatus(dataTeamCard, jGameDayId) {
  function compareGameday() {
    if (+dataTeamCard["userWildCardMatchday"] === jGameDayId) {
      //used in current
      return config.wildCardStatus.usedInCurrent;
    } else if (+dataTeamCard["userWildCardMatchday"] < jGameDayId) {
      //used previous
      return config.wildCardStatus.usedInBefore;
    } else if (+dataTeamCard["userWildCardMatchday"] > jGameDayId) {
      //used in next MD
      return config.wildCardStatus.usedInNext;
    }
  }

  if (+dataTeamCard["isAccounting"] === 0) {
    if (+dataTeamCard.isWildCardTaken === 1) {
      return compareGameday();
    } else {
      //not started //unlimited
      return config.wildCardStatus.notStarted;
    }
  } else if (+dataTeamCard["isAccounting"] === 1) {
    if (+dataTeamCard.isWildCardTaken === -1) {
      //used in current
      return config.wildCardStatus.usedInCurrentTemp;
    } else if (+dataTeamCard.isWildCardTaken === 0) {
      //started not used //you can take
      return config.wildCardStatus.startedAndNotUsed;
    } else if (+dataTeamCard.isWildCardTaken === 1) {
      return compareGameday();
    }
  }
}

export function getBoosterStatus(dataTeamCard, jGameDayId) {
  if (
    +dataTeamCard["isBoosterOneActive"] === 0 &&
    +dataTeamCard.isBoosterOneTaken === 0
  ) {
    //not started //unlimited
    return config.limitlessBoosterStatus.notStarted;
  } else if (
    +dataTeamCard["isBoosterOneActive"] === 1 &&
    +dataTeamCard.isBoosterOneTaken === 0
  ) {
    //started not used //you can take
    return config.limitlessBoosterStatus.startedAndNotUsed;
  } else if (
    +dataTeamCard["isBoosterOneActive"] === 1 &&
    +dataTeamCard.isBoosterOneTaken === 1
  ) {
    //started and used //used
    if (
      +dataTeamCard["boosterOneMdID"] === jGameDayId &&
      +dataTeamCard.isBoosterOneTaken === 1
    ) {
      //used in current
      return config.limitlessBoosterStatus.usedInCurrent;
    } else if (
      +dataTeamCard["boosterOneMdID"] < jGameDayId &&
      +dataTeamCard.isBoosterOneTaken === 1
    ) {
      //used previous
      return config.limitlessBoosterStatus.usedInBefore;
    } else if (
      dataTeamCard["boosterOneMdID"] > jGameDayId &&
      +dataTeamCard.isBoosterOneTaken === 1
    ) {
      return config.limitlessBoosterStatus.usedInNext;
    }
  } else if (
    +dataTeamCard["isBoosterOneActive"] === 0 &&
    +dataTeamCard.isBoosterOneTaken === 1
  ) {
    //unlimited and used before //used
    /*if (dataTeamCard.BoosterOneGDID === jGameDayId && dataTeamCard.IsWildCardTaken === 1) {
      //used in current
      return config.wildCardStatus.usedInCurrent;
    }
    else if (dataTeamCard.BoosterOneGDID !== jGameDayId && dataTeamCard.IsWildCardTaken === 1) {
      //used previous
      return config.wildCardStatus.usedInBefore;
    }*/
    return config.limitlessBoosterStatus.notStarted;
  } else if (+dataTeamCard.isBoosterOneTaken === -1) {
    //used in current
    return config.limitlessBoosterStatus.usedInCurrentTemp;
  }
}

export function isElementInViewport(el) {
  if (el) {
    let top = el.offsetTop;
    let left = el.offsetLeft;
    let width = el.offsetWidth;
    let height = el.offsetHeight;
    while (el.offsetParent) {
      el = el.offsetParent;
      top += el.offsetTop;
      left += el.offsetLeft;
    }
    return (
      top < window.pageYOffset + window.innerHeight &&
      left < window.pageXOffset + window.innerWidth &&
      top + height > window.pageYOffset &&
      left + width > window.pageXOffset
    );
  }
}

export function detectAdBlocker(setState) {
  const head = document.getElementsByTagName("head")[0];

  const noAdBlockDetected = () => {
    // alert("false not detected")
    setState(true, typeof window.twttr == "object");
    // common.setLocalStorage("isAdBlocked", false);
    // return false
  };
  const adBlockDetected = () => {
    // alert("true detected")
    setState(true, typeof window.twttr == "object");
    // common.setLocalStorage("isAdBlocked", true);
  };
  // clean up stale bait
  const oldScript = document.getElementById("adblock-detection");
  if (oldScript) {
    head.removeChild(oldScript);
  }
  // we will dynamically generate some 'bait'.
  const script = document.createElement("script");
  script.id = "adblock-detection";
  script.type = "text/javascript";
  script.src = "https://static.ads-twitter.com/uwt.js";
  script.onload = noAdBlockDetected;
  script.onerror = adBlockDetected;
  head.appendChild(script);
}

/* eslint-disable */
export const dateFormat = (function () {
  let d = /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZ]|"[^"]*"|'[ ^']*'/g,
    f =
      /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g,
    c = /[^-+\dA-Z]/g,
    b = function (a, g) {
      for (a = String(a), g = g || 2; a.length < g; ) {
        a = "0" + a;
      }
      return a;
    };
  return function (x, j, a) {
    let A = dateFormat;
    if (
      (1 !== arguments.length ||
        "[object String]" !== Object.prototype.toString.call(x) ||
        /\d/.test(x) ||
        ((j = x), (x = void 0)),
      (x = x ? new Date(x) : new Date()),
      isNaN(x))
    ) {
      throw SyntaxError("invalid date");
    }
    (j = String(A.masks[j] || j || A.masks["default"])),
      "UTC:" === j.slice(0, 4) && ((j = j.slice(4)), (a = !0));
    let C = a ? "getUTC" : "get",
      q = x[C + "Date"](),
      e = x[C + "Day"](),
      B = x[C + "Month"](),
      w = x[C + "FullYear"](),
      k = x[C + "Hours"](),
      m = x[C + "Minutes"](),
      t = x[C + "Seconds"](),
      z = x[C + "Milliseconds"](),
      v = a ? 0 : x.getTimezoneOffset(),
      p = {
        d: q,
        dd: b(q),
        ddd: A.i18n.dayNames[e],
        dddd:
          window.TRANS && window.TRANS[A.i18n.dayNames[e + 7]]
            ? window.TRANS[A.i18n.dayNames[e + 7]]
            : A.i18n.dayNames[e + 7],
        m: B + 1,
        mm: b(B + 1),
        mmm: A.i18n.monthNames[B],
        mmmm:
          window.TRANS && window.TRANS[A.i18n.monthNames[B + 12]]
            ? window.TRANS[A.i18n.monthNames[B + 12]]
            : A.i18n.monthNames[B + 12],
        yy: String(w).slice(2),
        yyyy: w,
        h: k % 12 || 12,
        hh: b(k % 12 || 12),
        H: k,
        HH: b(k),
        M: m,
        MM: b(m),
        s: t,
        ss: b(t),
        l: b(z, 3),
        L: b(z > 99 ? Math.round(z / 10) : z),
        t: 12 > k ? "a" : "p",
        tt: 12 > k ? "am" : "pm",
        T: 12 > k ? "A" : "P",
        TT: 12 > k ? "AM" : "PM",
        Z: a ? "UTC" : (String(x).match(f) || [""]).pop().replace(c, ""),
        o:
          (v > 0 ? "-" : "+") +
          b(100 * Math.floor(Math.abs(v) / 60) + (Math.abs(v) % 60), 4),
        S: ["th", "st", "nd", "rd"][
          q % 10 > 3 ? 0 : (((q % 100) - (q % 10) !== 10) * q) % 10
        ],
      };
    return j.replace(d, function (g) {
      return g in p ? p[g] : g.slice(1, g.length - 1);
    });
  };
})();
(dateFormat.masks = {
  default: "ddd mmm dd yyyy HH:MM:ss",
  shortDate: "m/d/yy",
  mediumDate: "mmm d, yyyy",
  longDate: "mmmm d, yyyy",
  fullDate: "dddd, mmmm d, yyyy",
  shortTime: "h:MM TT",
  mediumTime: "h:MM:ss TT",
  longTime: "h:MM:ss TT Z",
  isoDate: "yyyy-mm-dd",
  isoTime: "HH:MM:ss",
  isoDateTime: "yyyy-mm-dd'T'HH:MM:ss",
  isoUtcDateTime: "UTC:yyyy-mm-dd'T'HH:MM:ss'Z'",
}),
  (dateFormat.i18n = {
    dayNames: [
      "Sun",
      "Mon",
      "Tue",
      "Wed",
      "Thu",
      "Fri",
      "Sat",
      "sunday", //(window.TRANS && window.TRANS.sunday ? window.TRANS.sunday : 'Sunday'),
      "monday", //(window.TRANS && window.TRANS.monday ? window.TRANS.monday : 'Monday'),
      "tuesday", //(window.TRANS && window.TRANS.tuesday ? window.TRANS.tuesday : 'Tuesday'),
      "wednesday", //(window.TRANS && window.TRANS.wednesday ? window.TRANS.wednesday : 'Wednesday'),
      "thursday", //(window.TRANS && window.TRANS.thursday ? window.TRANS.thursday : 'Thursday'),
      "friday", //(window.TRANS && window.TRANS.friday ? window.TRANS.friday : 'Friday'),
      "saturday",
    ], //(window.TRANS && window.TRANS.saturday ? window.TRANS.saturday : 'Saturday')],
    monthNames: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
      "January",
      "February",
      "March",
      "April",
      "May",
      "june" /*(window.TRANS && window.TRANS.june ? window.TRANS.june : 'June')*/,
      "july" /*(window.TRANS && window.TRANS.july ? window.TRANS.july : 'July')*/,
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
  }),
  (Date.prototype.format = function (a, b) {
    return dateFormat(this, a, b);
  });
/* eslint-enable */
export function calcTime(sDate, offset = "+0") {
  // create Date object for current location
  let d = new Date(sDate); // convert to msec
  // add local time zone offset
  // get UTC time in msec
  let utc = d.getTime() + d.getTimezoneOffset() * 60000; // create new Date object for different city
  // using supplied offset
  let nd = new Date(utc + 3600000 * offset); // return time as a string
  return nd.toISOString();
}

export function getDataFromCookie(key, loginData) {
  let COOKIE_GM = config.COOKIE_GM;
  let parsedCookieGM = null;
  let value = null;
  parsedCookieGM = (loginData && loginData[config.COOKIE_GM]) || null;
  if (parsedCookieGM && parsedCookieGM[key]) {
    value = parsedCookieGM[key];
  }
  return value;
}

export function getTeamName(logindata) {
  let COOKIE_GM = config.COOKIE_GM;
  let parsedCookieGM = null;
  let teamName = null;
  parsedCookieGM =
    (logindata && logindata.data && logindata.data[config.COOKIE_GM]) || null;
  if (parsedCookieGM && parsedCookieGM["teamName"]) {
    teamName = decodeURIComponent(parsedCookieGM["teamName"]);
  }
  return teamName;
}

export function getCountryId(logindata) {
  let COOKIE_GM = config.COOKIE_GM;
  let parsedCookieGM = null;
  let countryId = null;
  parsedCookieGM =
    (logindata && logindata.data && logindata.data[config.COOKIE_GM]) || null;
  if (parsedCookieGM && parsedCookieGM["countryId"] != null) {
    countryId = parsedCookieGM["countryId"];
  }
  return countryId;
}

export function getLoginCookie() {
  let cookie = getCookie(config.COOKIE_GM);
  let returnCookie = null;
  try {
    if (cookie) {
      cookie = window.decodeURIComponent(cookie);
      let parsedCookie = JSON.parse(cookie);
      if (parsedCookie) {
        returnCookie = parsedCookie;
      }
    }
    return returnCookie;
  } catch (error) {
    if (cookie) {
      cookie = window.decodeURIComponent(cookie);
      let cookieSpecial = cookie.replace(
        /[\x00-\x09\x0B-\x0C\x0E-\x1F\x7F-\x9F]/g,
        ""
      );
      let parsedCookie = JSON.parse(cookieSpecial);
      if (parsedCookie) {
        returnCookie = parsedCookie;
      }
    }
    return returnCookie;
  }
}

export const deleteAllCookies = (reloadPage) => {
  var cookies = document.cookie.split(";");
  let exDate = new Date();
  exDate.setDate(exDate.getDate() + -1);
  // reloadPage && deleteAllLocalStorage();
  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i];
    var eqPos = cookie.indexOf("=");
    var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;

    document.cookie =
      name +
      "=;expires=" +
      exDate.toUTCString() +
      ";domain=" +
      config.sDomain +
      ";path=/";

    document.cookie = name + "=;expires=" + exDate.toUTCString() + ";path=/";
  }
  //
  //core.removeLocalStorageValue(config.enumCookie.inviteCookie);
  if (reloadPage) {
    window.location.reload();
  }
};

export function getPlayingPlayers(arrPlayers, liveScore) {
  if (liveScore && liveScore.totalPoints) {
    return filter(arrPlayers, (player) => {
      const livePlyscore = liveScore.totalPoints;
      const Id = player.playerid;
      if (player.benchposition == 0) {
        if (
          livePlyscore &&
          livePlyscore[Id] !== null &&
          livePlyscore[Id] !== undefined &&
          livePlyscore[Id] !== ""
        ) {
          player.liveScore = livePlyscore[Id];
          return player;
        }
      }
    });
  }
}

export const getBoostersObject = (compBoostersList, userBoostersList) => {
  let boosters = [];
  userBoostersList &&
    userBoostersList.forEach((objUser) => {
      compBoostersList &&
        compBoostersList.forEach((objComp, ind) => {
          if (objComp.BoosterId === objUser.Id) {
            boosters.push(objComp);
            boosters[ind].GdId = objUser.GdId;
            boosters[ind].IsTaken = objUser.IsTaken;
            boosters[ind].IsActive = objUser.IsActive;
          }
        });
    });
  return boosters;
};

Date.daysBetween = function (date1, date2) {
  //Get 1 day in milliseconds
  // Convert both dates to milliseconds
  let date1_ms = date1.getTime();
  let date2_ms = date2.getTime();
  // Calculate the difference in milliseconds
  let difference_ms = date2_ms - date1_ms;
  let ms_Diff = difference_ms;
  //take out milliseconds
  difference_ms = difference_ms / 1000;
  let seconds = Math.floor(difference_ms % 60);
  difference_ms = difference_ms / 60;
  let minutes = Math.floor(difference_ms % 60);
  difference_ms = difference_ms / 60;
  let hours = Math.floor(difference_ms % 24);
  let days = Math.floor(difference_ms / 24);
  //hours = hours + (days * 24);
  let jTotal = days + hours + minutes + seconds;
  let jTotalHours = /*(days * 24) +*/ hours;
  let hoursText = "hr" + (jTotalHours > 1 ? "s" : "");
  let minutesText = "min" + (minutes > 1 ? "s" : "");
  let daysText = "day" + (days > 1 ? "s" : "");
  if (minutes < 0) {
    minutes = 0;
  }
  return {
    ms_Diff: ms_Diff,
    jTotal: jTotal,
    days: days < 0 ? 0 : days,
    hours: jTotalHours < 0 ? 0 : jTotalHours,
    minutes: minutes < 0 ? 0 : minutes,
    daysText: daysText,
    hoursText: hoursText,
    minutesText: minutesText,
    seconds: seconds < 0 ? 0 : seconds,
  };
};

//tracking
export const customTracking = (
  eventAction,
  pageName,
  eventLable,
  eventcat
) => {};

//======================Tracking======================
export const googleAnalyticsTracking = function (sTitle, sPath) {
  let fResp = false;
  if (window.lastPath !== sPath) {
    if (window.gtag) {
      window.gtag("config", config.GA_TRACKING_ID, {
        page_title: sTitle,
        page_path: sPath,
      });
    }
    window.lastPath = sPath;
    fResp = true;
  }
  return fResp;
};
export const googleAnalyticsEventTracking = function (
  action,
  category,
  opt_label,
  objExtra
) {
  if (window.gtag) {
    window.gtag("event", action, {
      event_category: category,
      event_label: opt_label,
      send_to: config.GA_TRACKING_ID,
    });
  }
};

//======================Tracking======================

//end

export const getPageName = (params) => {
  let pageName = "";
  if (window.location.pathname.indexOf("/manage-team") > -1) {
    pageName =
      params == "create/manage"
        ? "/uefaeuro2020fantasyfootball/my-team/manage/"
        : "/uefaeuro2020fantasyfootball/my-team/transfers/";
  } else {
    pageName = "/uefaeuro2020fantasyfootball/create-team/";
  }
  return pageName;
};

export const getGamedayOfStatus = (gamedays, mds) => {
  if (size(gamedays)) {
    let result = null;
    for (let g in gamedays) {
      if (gamedays[g].mds == mds) {
        result = { ...gamedays[g] };
        result.mdId = g;
      }
    }
    return result;
  }
  return null;
};

export const playerBySkill = (players) => {
  let playerList = [];

  // to get object like

  // playerList=[
  //   {
  //     skill: Number,
  //     arrPlayer: [],
  //     showAll: false,
  //   },
  // ]

  if (players) {
    Object.keys(config.positionMap).map((pos) => {
      playerList = [
        ...playerList,
        {
          skill: pos,
          arrPlayer: players.filter((player) => player.Skill == pos),
          showAll: false,
        },
      ];
    });
  }
  return playerList;
};

export const playerCalc = (teamData, skillId) => {
  let noOfPlayersOnBench =
    teamData &&
    teamData[0].filter((element) => {
      return element.id && element.skill == skillId;
    }).length;
  let noOfPlayersSkillWise =
    skillId &&
    teamData &&
    teamData[skillId].filter((elem) => {
      return elem.id;
    }).length;

  return noOfPlayersOnBench + noOfPlayersSkillWise;
};

export const getLivePlayerDetails = (playerId, scoring) => {
  let livePlayerDetails = {};
  let isPlayerLive = false;
  for (let i = 0; i < scoring.length; i++) {
    let objMatch = scoring[i];
    let gamedayPoints = objMatch.PlayerPoints.find((objPlyr, plyrIn) => {
      return playerId === objPlyr.PlayerId;
    });
    if (gamedayPoints?.PlayerId) {
      livePlayerDetails.GamedayPoints = gamedayPoints;
      let gamedayStats = objMatch.PlayerStats.find((objPlyr, plyrIn) => {
        return playerId === objPlyr.PlayerId;
      });
      livePlayerDetails.GamedayStats = gamedayStats;
      isPlayerLive = true;
      break;
    }
  }
  return { livePlayerDetails, isPlayerLive };
};

export const getOverallGamedayPoints = (
  scoring,
  teamData,
  boosterApplied,
  gamedayId
) => {
  let overallPoints = 0;
  forEach(orderToScan, (skillIndex) => {
    teamData[skillIndex].forEach((objPlr) => {
      let objPlyr = objPlr.DBDetails;
      scoring &&
        scoring.length &&
        scoring.forEach((objMtch) => {
          objMtch.PlayerPoints.forEach((objPlyrScr) => {
            if (
              objPlyr.Id === objPlyrScr.PlayerId &&
              objPlyrScr.GamedayId === gamedayId
            ) {
              let player = {};
              player.details = objPlyr;
              let playerXCoef =
                boosterApplied &&
                boosterApplied.BoosterId &&
                getPlayerBoosterCoefficient(player, boosterApplied);
              console.log(
                player.details.DisplayName,
                playerXCoef,
                "playerXCoef"
              );
              if (
                objPlyr.BenchPosition === 0 ||
                (objPlyr.BenchPosition !== 0 && boosterApplied?.BoosterId === 2)
              ) {
                overallPoints =
                  overallPoints +
                  objPlyrScr.TotalPoints *
                    (playerXCoef
                      ? playerXCoef
                      : objPlyr.IsCaptain === 1
                      ? 2
                      : 1);
              }
            }
          });
        });
    });
  });
  return overallPoints;
};

export const createModified = (Fixtures, playerCardActions) => {
  let nextFix = Fixtures[0];
  let selectedFixture = {};
  let nextFixCheck = playerCardActions.playerDetail.Fixtures.filter((f) => {
    return f.GamedayId === nextFix.GamedayId;
  });

  if (nextFixCheck.length) {
    let matchday = nextFixCheck[0];
    let filFix = playerCardActions.playerDetail.Fixtures.filter((f) => {
      return f.GamedayId === matchday.GamedayId;
    });

    let filFixPoints = playerCardActions.playerDetail.GamedayPoints.filter(
      (f) => {
        return f.GamedayId === matchday.GamedayId;
      }
    );

    let filFixStats = playerCardActions.playerDetail.GamedayStats.filter(
      (f) => {
        return f.GamedayId === matchday.GamedayId;
      }
    );

    selectedFixture = {
      ...matchday,
      ...filFix[0],
      GamedayPoints: filFixPoints[0] || {},
      GamedayStats: filFixStats[0] || {},
    };
  }

  return selectedFixture;
};

// version check function
export const checkIsAnyVersionChanged = () => {
  let splitisVersionChangeObj =
    getLocalStorage(config.isVersionChangeTrackKey) || [];
  if (splitisVersionChangeObj.includes(1)) {
    removeLocalStorage(config.isVersionChangeTrackKey, true);
    window.location.reload();
  }
};

// common logout function
export const logOutCall = (err) => {
  let apiParams = {
    endPoint: config?.WebConfig[config?.APINames?.Logout]
      ? config?.LOGINAPIBASEPATH + config?.WebConfig[config?.APINames?.Logout]
      : config?.LOGINAPIBASEPATH + "logout",
    type: "POST",
    name: "Logout",
    params: { isReload: true },
  };
  getData(
    apiParams,
    (resp) => {
      clearLocalStorage();
      window.location.reload();
    },
    (error) => {
      if (err) {
        err(error);
      }
    }
  );
};
